(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('testData', ['enumService', testData]);

    function testData(enumService) {
        var enumCourseType = enumService.courseType;
        var service = {
            MyTrainingPoint: MyTrainingPoint,
            SysTypesList: SysTypesList,
            FCLicenseList: FCLicenseList,
            CourseItem: CourseItem,
            PublishedActivity: PublishedActivity,
            CourseSession: CourseSession,
            ExamSurveyContent: ExamSurveyContent,
            InteractionData: InteractionData,
            MyUnfinishedActivities: MyUnfinishedActivities,
            MyFinishedActivities: MyFinishedActivities,
            EnrollmentAvailableAction: EnrollmentAvailableAction,
            EnrollmentAction: EnrollmentAction,
            FCCertificatedLicenseAdd: FCCertificatedLicenseAdd,
            FCCertificatedLicenseList: FCCertificatedLicenseList,
            FCAuthorizedHoursList: FCAuthorizedHoursList,
            ExternalTrainingApplication: ExternalTrainingApplication,
            FCEnrollableActivities: FCEnrollableActivities,
            LearningRecordCommit: LearningRecordCommit,
        };

        return service;
        /**
         * 1.訓練存摺點數
         * @returns
         */
        function MyTrainingPoint(year) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultDefault;
            var resultYear2013;
            var resultYear2014;
            var resultYear2015;
            var resultYear2016;
            resultDefault = {
                Status: '200',
                Data: {
                    remainPoint: 0,
                    trainingPoints: []
                },
                ErrorMessage: '123'
            };
            resultYear2013 = {
                Status: '200',
                Data: {
                    remainPoint: 0,
                    trainingPoints: [{
                        courseName: "2013課程",
                        courseTime: "2013/09/21~2013/09/21",
                        courseType: "外訓課程",
                        point: 250
                    }]
                },
                ErrorMessage: ''
            };
            resultYear2014 = {
                "Status": "200",
                "Data": {
                    "remainPoint": 10000,
                    "trainingPoints": [{
                        courseName: "2014課程1",
                        courseTime: "2014/03/05~2014/03/14",
                        courseType: "外訓課程",
                        point: 250
                    },
                    {
                        courseName: "2014課程2",
                        courseTime: "2014/07/13~2014/07/13",
                        courseType: "線上課程",
                        point: 250
                    },
                    ]
                },
                "ErrorMessage": ""
            };
            resultYear2015 = { "Status": "200", "Data": { "remainPoint": 10000, "trainingPoints": [] }, "ErrorMessage": "" };
            resultYear2016 = { "Status": "200", "Data": { "remainPoint": 10000, "trainingPoints": [] }, "ErrorMessage": "" };
            switch (year + '') {
                case '2013':
                    result = resultYear2013;
                    break;
                case '2014':
                    result = resultYear2014;
                    break;
                case '2015':
                    result = resultYear2015;
                    break;
                case '2016':
                    result = resultYear2016;
                    break;
                default:
                    result = resultYear2016;
                    break;
            }
            return { data: result };
        }

        /**
         * 2-1.取得下拉選單資料_金融證照類別
         * @returns
         */
        function SysTypesList(type) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultType2; /**金融證照類別 */
            var resultType3; /**外訓費用貨幣種類 */
            var resultType4; /**外訓種類 */
            var resultType5; /**主辦單位 */
            resultType2 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                },
                {
                    "id": 7,
                    "name": "人力資源類"
                },
                {
                    "id": 8,
                    "name": "行內自辦證照/資格類資格類資格類資格類資格類"
                },
                {
                    "id": 15,
                    "name": "法金人才庫類"
                },
                {
                    "id": 6,
                    "name": "金融證照類"
                },
                {
                    "id": 12,
                    "name": "專案管理類"
                },
                {
                    "id": 9,
                    "name": "勞工安全類"
                }
                ],
                "ErrorMessage": ""
            };
            resultType3 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                },
                {
                    "id": 0,
                    "name": "台幣"
                }
                ],
                "ErrorMessage": ""
            };
            resultType4 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                },
                {
                    "id": 0,
                    "name": "國外外訓"
                },
                {
                    "id": 1,
                    "name": "一般外訓"
                },
                {
                    "id": 2,
                    "name": "外語進修補助"
                },
                {
                    "id": 3,
                    "name": "電腦進修補助"
                },
                {
                    "id": 4,
                    "name": "考試補助"
                }
                ],
                "ErrorMessage": ""
            };
            resultType5 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                },
                {
                    "id": 1,
                    "name": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"
                },
                {
                    "id": 3,
                    "name": "路透社"
                },
                {
                    "id": 4,
                    "name": "工研院台北學習中心"
                },
                {
                    "id": 5,
                    "name": "中央存款保險股份有限公司"
                },
                {
                    "id": 6,
                    "name": "中原大學推廣教育中心"
                },
                {
                    "id": 7,
                    "name": "中國文化大學推廣教育部"
                },
                {
                    "id": 8,
                    "name": "中國生產力中心"
                },
                {
                    "id": 9,
                    "name": "中華人力資源管理協會"
                },
                {
                    "id": 10,
                    "name": "中華人事主管協會"
                },
                {
                    "id": 11,
                    "name": "中華公司治理協會"
                },
                {
                    "id": 12,
                    "name": "中華民國工商協進會"
                },
                {
                    "id": 13,
                    "name": "中華民國工業安全衛生協會"
                },
                {
                    "id": 14,
                    "name": "中華民國內部稽核協會"
                },
                {
                    "id": 15,
                    "name": "中華民國公司組織研究發展協會"
                },
                {
                    "id": 16,
                    "name": "信託公會"
                },
                {
                    "id": 17,
                    "name": "中華民國退休基金協會〈萬寶資產管理集團〉"
                },
                {
                    "id": 18,
                    "name": "中華民國票券金融商業同業公會"
                },
                {
                    "id": 19,
                    "name": "中華民國勞資關係協進會"
                },
                {
                    "id": 20,
                    "name": "中華民國銀行商業同業公會全國聯合會"
                },
                {
                    "id": 21,
                    "name": "中華民國職工福利發展協會"
                },
                {
                    "id": 22,
                    "name": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "id": 23,
                    "name": "中華汽車培訓中心"
                },
                {
                    "id": 24,
                    "name": "中華徵信所"
                },
                {
                    "id": 25,
                    "name": "台灣金融研訓院"
                },
                {
                    "id": 26,
                    "name": "台大進修推廣部"
                },
                {
                    "id": 27,
                    "name": "國稅局"
                },
                {
                    "id": 28,
                    "name": "台北市進出口商業同業公會"
                },
                {
                    "id": 29,
                    "name": "台北金融研究發展基金會"
                },
                {
                    "id": 30,
                    "name": "台北恆逸教訓訓練中心"
                },
                {
                    "id": 31,
                    "name": "台北富蘭德林諮詢有限公司"
                },
                {
                    "id": 32,
                    "name": "證券商業同業公會"
                },
                {
                    "id": 33,
                    "name": "證券暨期貨市場發展基金會"
                },
                {
                    "id": 34,
                    "name": "台北富蘭德林諮詢有限公司"
                },
                {
                    "id": 35,
                    "name": "台灣金融服務業聯合總會"
                },
                {
                    "id": 36,
                    "name": "台灣金融服務業聯合總會"
                },
                {
                    "id": 37,
                    "name": "台灣期貨交易所股份有限公司"
                },
                {
                    "id": 38,
                    "name": "巨匠電腦"
                },
                {
                    "id": 39,
                    "name": "行政院金融管理委員會"
                },
                {
                    "id": 40,
                    "name": "行政院勞工委員會"
                },
                {
                    "id": 41,
                    "name": "何嘉仁國際教育學院"
                },
                {
                    "id": 42,
                    "name": "投信投顧公會"
                },
                {
                    "id": 43,
                    "name": "亞太教育訓練"
                },
                {
                    "id": 44,
                    "name": "兩岸經華諮詢顧問股份有限公司"
                },
                {
                    "id": 45,
                    "name": "券商同業公會"
                },
                {
                    "id": 46,
                    "name": "卓越人生企管顧問公司"
                },
                {
                    "id": 47,
                    "name": "和風談判學院"
                },
                {
                    "id": 48,
                    "name": "旺旺中時媒體集團"
                },
                {
                    "id": 49,
                    "name": "東方匯理銀行"
                },
                {
                    "id": 50,
                    "name": "法國外貿銀行"
                },
                {
                    "id": 51,
                    "name": "社團法人中華採購供應管理協會"
                },
                {
                    "id": 52,
                    "name": "花旗銀行"
                },
                {
                    "id": 53,
                    "name": "金管會"
                },
                {
                    "id": 54,
                    "name": "前瞻國際顧問(股)公司"
                },
                {
                    "id": 55,
                    "name": "施羅德證券投資信託股份有限公司"
                },
                {
                    "id": 56,
                    "name": "美國銀行(Bank of America)"
                },
                {
                    "id": 57,
                    "name": "英商渣打銀行"
                },
                {
                    "id": 58,
                    "name": "財團法人會計研究發展基金會"
                },
                {
                    "id": 59,
                    "name": "高雄市銀行公會"
                },
                {
                    "id": 60,
                    "name": "動腦傳播股份有限公司"
                },
                {
                    "id": 61,
                    "name": "國際商會中華民國總會"
                },
                {
                    "id": 62,
                    "name": "富蘭德林"
                },
                {
                    "id": 63,
                    "name": "彭博資訊"
                },
                {
                    "id": 64,
                    "name": "渣打銀行"
                },
                {
                    "id": 65,
                    "name": "勤業眾信會計師事務所\t"
                }
                ],
                "ErrorMessage": ""
            };
            switch (type) {
                case 2:
                    result = resultType2;
                    break;
                case 3:
                    result = resultType3;
                    break;
                case 4:
                    result = resultType4;
                    break;
                case 5:
                    result = resultType5;
                    break;
                default:
                    break;
            }
            return { data: result };
        }
        /**
         * 2-3.取得下拉選單資料_取得金融證照名稱
         * @returns
         */
        function FCLicenseList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "attTypes": "",
                    "id": 159,
                    "name": "ARM專業能力檢定測驗(大會考)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 177,
                    "name": "AU-910 Generic Knowledge",
                    "organization": "Australian Securities & Investments Commission"
                },
                {
                    "attTypes": "",
                    "id": 190,
                    "name": "AU-927 Foreign Exchange - Knowledge & Skill",
                    "organization": "Australian Securities & Investments Commission"
                },
                {
                    "attTypes": "",
                    "id": 189,
                    "name": "AU-927 Foreign Exchange - Knowledge only",
                    "organization": "Australian Securities & Investments Commission"
                },
                {
                    "attTypes": "",
                    "id": 85,
                    "name": "CFA(全階)",
                    "organization": "台灣理財顧問認證協會"
                },
                {
                    "attTypes": "",
                    "id": 83,
                    "name": "CFA(第一階段)",
                    "organization": "台灣理財顧問認證協會"
                },
                {
                    "attTypes": "",
                    "id": 84,
                    "name": "CFA(第二階段)",
                    "organization": "台灣理財顧問認證協會"
                },
                {
                    "attTypes": "",
                    "id": 86,
                    "name": "CFP",
                    "organization": "台灣理財顧問認證協會"
                },
                {
                    "attTypes": "",
                    "id": 148,
                    "name": "CIA 國際內部稽核師",
                    "organization": "中華民國內部稽核協會"
                },
                {
                    "attTypes": "",
                    "id": 149,
                    "name": "CISA 國際電腦稽核師",
                    "organization": "中華民國內部稽核協會"
                },
                {
                    "attTypes": "",
                    "id": 87,
                    "name": "CPA(會計師)",
                    "organization": "考試院"
                },
                {
                    "attTypes": "",
                    "id": 88,
                    "name": "CSIA",
                    "organization": "美國金融管理學會"
                },
                {
                    "attTypes": "",
                    "id": 29,
                    "name": "e-HR管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 179,
                    "name": "Internal Audit in Financial Institution 金融機構稽核課程(HK)",
                    "organization": "香港銀行學會"
                },
                {
                    "attTypes": "",
                    "id": 89,
                    "name": "MFP",
                    "organization": "美國金融管理學會"
                },
                {
                    "attTypes": "",
                    "id": 90,
                    "name": "PMP國際專案經理人認証班",
                    "organization": "Project Management Institute(PMI)"
                },
                {
                    "attTypes": "",
                    "id": 147,
                    "name": "PMP國際專案管理師",
                    "organization": "Project Management Institute(PMI)"
                },
                {
                    "attTypes": "",
                    "id": 37,
                    "name": "一級講師",
                    "organization": "人力資源處"
                },
                {
                    "attTypes": "",
                    "id": 58,
                    "name": "乙種勞工安全衛生業務主管",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 26,
                    "name": "人力資源中階主管",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 12,
                    "name": "人民幣辨識資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 76,
                    "name": "人身保險代理人",
                    "organization": "中華民國考選部"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 79,
                    "name": "人身保險業務員投資型保險商品資格測驗合格",
                    "organization": "財團法人保險事業發展中心"
                },
                {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 46,
                    "name": "人身保險業務員投資型商品資格登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 45,
                    "name": "人身保險業務員登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 77,
                    "name": "人身保險業務員資格測驗合格",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 82,
                    "name": "人身保險業務員銷售外幣收付非投資型保險商品資格測驗合格",
                    "organization": "財團法人保險事業發展中心"
                },
                {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 47,
                    "name": "人身保險業務員銷售外幣收付非投資型保險商品資格登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 153,
                    "name": "人身保險經紀人",
                    "organization": "中華民國考選部"
                },
                {
                    "attTypes": "",
                    "id": 24,
                    "name": "大陸人力資源管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 158,
                    "name": "大陸人力資源與勞動關係管理師",
                    "organization": "中華人事主管協會"
                },
                {
                    "attTypes": "",
                    "id": 78,
                    "name": "不良債權處理實務研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 124,
                    "name": "不動產鑑價測驗合格",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 34,
                    "name": "不動產鑑價資格取得",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 73,
                    "name": "內部稽核師",
                    "organization": "中華民國內部稽核協會"
                },
                {
                    "attTypes": "",
                    "id": 131,
                    "name": "內部講師訓完訓資格",
                    "organization": "人力資源處"
                },
                {
                    "attTypes": "",
                    "id": 134,
                    "name": "分行經理內部控制",
                    "organization": "通路營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 59,
                    "name": "丙種勞工安全衛生業務主管",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 40,
                    "name": "外匯及衍生性金融商品之風險管理研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 91,
                    "name": "外匯交易專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 64,
                    "name": "外匯指定分行外匯人員資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 8,
                    "name": "外匯經辦人員資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 185,
                    "name": "外匯經辦人員資格(僅限客服部)",
                    "organization": "通路營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 9,
                    "name": "外匯覆核人員資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 186,
                    "name": "外匯覆核人員資格(僅限客服部)",
                    "organization": "通路營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 22,
                    "name": "生涯發展諮商師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 57,
                    "name": "甲種勞工安全衛生業務主管",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 74,
                    "name": "企業內部控制基本能力測驗",
                    "organization": "證券暨期貨市場發展基金會"
                },
                {
                    "attTypes": "",
                    "id": 157,
                    "name": "全民財經檢定(General Economic and Financial Test)",
                    "organization": "經濟日報"
                },
                {
                    "attTypes": "",
                    "id": 92,
                    "name": "存款開戶課程認證",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 36,
                    "name": "年度優良講師",
                    "organization": "人力資源處"
                },
                {
                    "attTypes": "",
                    "id": 156,
                    "name": "利率變動型年金資格(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 63,
                    "name": "投信投顧相關法規(含自律規範)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 120,
                    "name": "投信投顧業務員",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "身分證正反面影本, 最高學歷證書影本, 投信投顧業務員證照影本(或信託業務證照+投信投顧法規證照影本), 金融常識與職業道德測驗證書影本, 登錄聲明書 (下載路徑：台新大學>新手上路>新手教材>同仁篇>證照管理>投顧人員聲明書103年版), 請注意，此證照僅供「理財商品處」同仁申請登錄",
                    "id": 127,
                    "name": "投信投顧業務員-一般業務員(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 129,
                    "name": "投信投顧業務員-基金經理人(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 130,
                    "name": "投信投顧業務員-基金經理人部主管(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 128,
                    "name": "投信投顧業務員-部主管(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 50,
                    "name": "防火管理人員",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 109,
                    "name": "其他類證照",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 21,
                    "name": "知識管理管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 102,
                    "name": "股務業務員資格",
                    "organization": "證券暨期貨市場發展基金會"
                },
                {
                    "attTypes": "",
                    "id": 94,
                    "name": "初階外匯人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 96,
                    "name": "初階授信人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 100,
                    "name": "金融人員授信擔保品估價專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 99,
                    "name": "金融市場常識與職業道德",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 180,
                    "name": "金融管理師(FMA)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                },
                {
                    "attTypes": "",
                    "id": 204,
                    "name": "金融數位力知識檢定測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 14,
                    "name": "信託業務人員信託業務專業測驗",
                    "organization": "中華民國信託業商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 65,
                    "name": "信託業務人員信託業務專業測驗【信託法規乙科】",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "不需檢附任何文件",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 30,
                    "name": "信託督導人員實務研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "不需檢附任何文件",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 31,
                    "name": "信託管理人員研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "不需檢附任何文件",
                    "id": 6,
                    "name": "信託管理人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 80,
                    "name": "保險財產規劃師",
                    "organization": "中華民國個人財產規劃人員協會"
                },
                {
                    "attTypes": "",
                    "id": 51,
                    "name": "急救人員訓練",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 202,
                    "name": "衍生性金融商品及風險管理培訓班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 41,
                    "name": "衍生性金融商品自辦課程測驗",
                    "organization": "金融市場處"
                },
                {
                    "attTypes": "",
                    "id": 205,
                    "name": "衍生性金融商品銷售人員資格測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 192,
                    "name": "衍生性商品推介人員(登錄銀行公會)",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "通過證書正本",
                    "id": 193,
                    "name": "風險管理基本能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 135,
                    "name": "香港證券-卷一 基本證券及期貨規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 141,
                    "name": "香港證券-卷七 金融市場",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 143,
                    "name": "香港證券-卷九 衍生工具",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 136,
                    "name": "香港證券-卷二 證券規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 142,
                    "name": "香港證券-卷八 證券",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 144,
                    "name": "香港證券-卷十 信貸評級服務",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 145,
                    "name": "香港證券-卷十一 機構融資",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 146,
                    "name": "香港證券-卷十二 資產管理",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 137,
                    "name": "香港證券-卷三 衍生工具規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 139,
                    "name": "香港證券-卷五 機構融資規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 140,
                    "name": "香港證券-卷六 資產管理規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 138,
                    "name": "香港證券-卷四 信貸評級服務規例",
                    "organization": "香港證券專業協會"
                },
                {
                    "attTypes": "",
                    "id": 15,
                    "name": "員工任用管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 18,
                    "name": "員工福利管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 17,
                    "name": "員工薪酬管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 19,
                    "name": "員工關係管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 161,
                    "name": "晉升10職等準RM簡報(適用產金/服金/海外/產品)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 194,
                    "name": "晉升11職等PM/PS專業能力檢定測驗>僅透過HR上傳名單",
                    "organization": "法金產品行銷處"
                },
                {
                    "attTypes": "",
                    "id": 162,
                    "name": "晉升11職等RM專業能力檢定測驗(大會考)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 165,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 201,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/系統專案組)>僅透過HR上傳資格",
                    "organization": "法金管理處系統專案組"
                },
                {
                    "attTypes": "",
                    "id": 197,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/法金作業部)>僅透過HR上傳資格",
                    "organization": "法金管理處法金作業部"
                },
                {
                    "attTypes": "",
                    "id": 199,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/法金管理部)>僅透過HR上傳資格",
                    "organization": "法金管理處法金管理部"
                },
                {
                    "attTypes": "",
                    "id": 200,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/金融交易作業部)>僅透過HR上傳資格",
                    "organization": "法金管理處金融交易作業部"
                },
                {
                    "attTypes": "",
                    "id": 198,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/客戶服務部)>僅透過HR上傳資格",
                    "organization": "法金管理處客戶服務部"
                },
                {
                    "attTypes": "",
                    "id": 196,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/建北分行)>僅透過HR上傳資格",
                    "organization": "法金管理處建北分行"
                },
                {
                    "attTypes": "",
                    "id": 195,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/國外部)>僅透過HR上傳資格",
                    "organization": "法金管理處國外部"
                },
                {
                    "attTypes": "",
                    "id": 163,
                    "name": "晉升12職等RM簡報>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 164,
                    "name": "晉升12職等專題簡報(適用PM/除國際聯貸以外之PS、TMO及SU)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 166,
                    "name": "晉升13職等PM專題簡報>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 160,
                    "name": "晉升9職等準RM簡報(適用環貿金融處)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 178,
                    "name": "晉升RM資格(適用產金/服金)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                },
                {
                    "attTypes": "",
                    "id": 182,
                    "name": "特級金融管理師(CFMA)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                },
                {
                    "attTypes": "",
                    "id": 152,
                    "name": "租賃人才養成認證班",
                    "organization": "台北市租賃公會"
                },
                {
                    "attTypes": "",
                    "id": 16,
                    "name": "訓練發展管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 103,
                    "name": "財金風險管理分析師",
                    "organization": "Global Association of Risk Professionals (GARP)，全球風險專業管理協會"
                },
                {
                    "attTypes": "",
                    "id": 154,
                    "name": "財產保險代理人",
                    "organization": "中華民國考選部"
                },
                {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 176,
                    "name": "財產保險業務員(限招攬傷害及健康險)(登錄產險公會)",
                    "organization": "中華民國產物保險商業同業公會"
                },
                {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "organization": "中華民國產物保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 81,
                    "name": "財產保險業務員資格測驗合格",
                    "organization": "中華民國產物保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 155,
                    "name": "財產保險經紀人",
                    "organization": "中華民國考選部"
                },
                {
                    "attTypes": "",
                    "id": 181,
                    "name": "高級金融管理師(FMA+)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                },
                {
                    "attTypes": "",
                    "id": 188,
                    "name": "商金現勘訪廠執照資格取得",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 126,
                    "name": "基礎人資管理師",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 98,
                    "name": "理財規劃人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 35,
                    "name": "現勘",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 105,
                    "name": "票券商業務員",
                    "organization": "中華民國票券金融商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 60,
                    "name": "勞工安全管理甲級技術士",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 53,
                    "name": "勞工安全管理師",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 56,
                    "name": "勞工安全衛生管理乙級技術士",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 52,
                    "name": "勞工安全衛生管理員",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 61,
                    "name": "勞工衛生管理甲級技術士",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 55,
                    "name": "勞工衛生管理師",
                    "organization": ""
                },
                {
                    "attTypes": "",
                    "id": 151,
                    "name": "勞健保暨勞基法管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 20,
                    "name": "勞動法令管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 117,
                    "name": "期貨分析師",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 119,
                    "name": "期貨交易分析人員",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "不需檢附任何文件",
                    "id": 42,
                    "name": "期貨信託基金銷售機構銷售人員(登錄期貨公會)",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 43,
                    "name": "期貨信託基金銷售機構銷售人員專業科目測驗成績合格證明",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 115,
                    "name": "期貨商業務員",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 116,
                    "name": "期貨商業務員(登錄期貨公會)",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 27,
                    "name": "策略性人力資源管理",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "通過證書影本, 登錄同意書 (下載路徑：台新大學>新手上路>新手教材>同仁篇>證照管理>台新銀行結構型商品推介人員資格資料變更註銷登錄申請暨同意書)",
                    "id": 150,
                    "name": "結構型商品推介人員(登錄銀行公會)",
                    "organization": "中華民國銀行商業同業公會"
                },
                {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 39,
                    "name": "結構型商品銷售人員資格測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "此證照目前已停用，請勿申請登錄。",
                    "id": 49,
                    "name": "結構型商品銷售自律規範測驗(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 95,
                    "name": "進階外匯人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 97,
                    "name": "進階授信人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 13,
                    "name": "開戶對保作業資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 93,
                    "name": "債券人員",
                    "organization": "證券暨期貨市場發展基金會"
                },
                {
                    "attTypes": "",
                    "id": 75,
                    "name": "債權委外催收人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 48,
                    "name": "傳統型年金資格(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 184,
                    "name": "新型分析工具認證-初階",
                    "organization": "客群經營處客戶關係管理部"
                },
                {
                    "attTypes": "",
                    "id": 125,
                    "name": "資料倉儲權限認證",
                    "organization": "人力資源處"
                },
                {
                    "attTypes": "",
                    "id": 66,
                    "name": "資產配置觀念與系統操作",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 106,
                    "name": "資產證券化基本能力測驗",
                    "organization": "證券暨期貨市場發展基金會"
                },
                {
                    "attTypes": "",
                    "id": 69,
                    "name": "電腦稽核研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 33,
                    "name": "對保資格取得",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 38,
                    "name": "認證講師",
                    "organization": "人力資源處"
                },
                {
                    "attTypes": "",
                    "id": 67,
                    "name": "銀行內部控制與內部稽核測驗",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 122,
                    "name": "銀行辦理財富管理業務-理財業務人員及其他人員",
                    "organization": "中華民國銀行商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 121,
                    "name": "銀行辦理財富管理業務-管理人員",
                    "organization": "中華民國銀行商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 123,
                    "name": "徵信測驗合格",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 32,
                    "name": "徵信資格取得",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 68,
                    "name": "稽核人員研習班",
                    "organization": "台灣金融研訓院"
                },
                {
                    "attTypes": "",
                    "id": 187,
                    "name": "親簽核對資格取得",
                    "organization": "個金授信管理處"
                },
                {
                    "attTypes": "",
                    "id": 28,
                    "name": "績效管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 23,
                    "name": "總務行政管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 62,
                    "name": "簡易外匯人員資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 25,
                    "name": "職能管理師",
                    "organization": "中華人力資源管理協會"
                },
                {
                    "attTypes": "",
                    "id": 11,
                    "name": "覆核作業資格",
                    "organization": "分行營運事業處"
                },
                {
                    "attTypes": "",
                    "id": 107,
                    "name": "證券交易相關法規與實務",
                    "organization": "證券暨期貨市場發展基金會"
                },
                {
                    "attTypes": "",
                    "id": 118,
                    "name": "證券投資分析人員",
                    "organization": "中華民國期貨業商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 70,
                    "name": "證券商內部稽核資格",
                    "organization": "中華民國證券商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 110,
                    "name": "證券商自有資本適足比率進階計算法申報人員測驗",
                    "organization": "台灣證券交易所"
                },
                {
                    "attTypes": "",
                    "id": 111,
                    "name": "證券商高級業務員",
                    "organization": "中華民國證券商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 112,
                    "name": "證券商高級業務員(登錄證券交易所)",
                    "organization": "台灣證券交易所"
                },
                {
                    "attTypes": "",
                    "id": 113,
                    "name": "證券商業務員",
                    "organization": "中華民國證券商業同業公會"
                },
                {
                    "attTypes": "",
                    "id": 114,
                    "name": "證券商業務員(登錄證券交易所)",
                    "organization": "台灣證券交易所"
                },
                {
                    "attTypes": "",
                    "id": 10,
                    "name": "驗印資格",
                    "organization": "分行營運事業處"
                }
                ],
                "ErrorMessage": ""
            };
            return { data: result };
        }

        /**
         * 3.取得課程教材
         * 顯示方式；下載附件
         */
        function CourseItem(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var CourseItemsDownload;
            var CourseItemsPdf;
            var CourseItemsVideo;
            CourseItemsDownload = {
                "Status": "200",
                "Data": {
                    "fileExt": "ZIP 文件",
                    "id": 1,
                    "name": "TIPS信託投資系統操作說明【91分鐘】(ZIP教材)",
                    "path": "Storage\\downloadFile.zip",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            CourseItemsPdf = {
                "Status": "200",
                "Data": {
                    "fileExt": "PDF 文件",
                    "id": 2,
                    "name": "經濟基本指標【57分鐘】",
                    "path": "Storage\\pdfFile.pdf",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            CourseItemsVideo = {
                "Status": "200",
                "Data": {
                    "fileExt": "MP4 文件",
                    "id": 3,
                    "name": "ETF介紹【19分鐘】",
                    // "path": "Storage\\videoFile.mp4",
                    "href": "-511951560-146372858133s7.mp4",
                    "path": "Storage\\Content\\2154\\",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            switch (params.ItemId) {
                case 2:
                    result = CourseItemsPdf;
                    break;
                case 3:
                    result = CourseItemsVideo;
                    break;
                case 1:
                    result = CourseItemsDownload;
                    break;
                default:
                    result = CourseItemsDownload;
                    break;
            }
            return { data: result };
        }

        /**
         * 4.取得課程列表
         * @returns
         */
        function PublishedActivity(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTW;
            var resultCN;
            var resultUS;

            resultTW = {
                Status: "200",
                Data: [{
                    "classificationId": 10,
                    "classificationName": "",
                    "courseId": 30390,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/10/05~2016/10/05",
                    "courseType": 5,
                    "courseTypeName": "教室測驗(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86917,
                    "sessionName": "20161005台新證券-法遵自評筆試(一般)【TEST】-教室測驗(繁體)"

                },
                {
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 52160,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/01/01~2016/12/31",
                    "courseType": 6,
                    "courseTypeName": "問卷(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86921,
                    "sessionName": "台新大學暨人資網站改版問卷調查(2016)(繁體)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 18,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/09/07~2017/12/31",
                    "courseType": 7,
                    "courseTypeName": "學程(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 1232,
                    "sessionName": "EMBO課程(2016下半年)[無對應資料](繁體)",
                }
                ],
                ErrorMessage: ""
            };
            resultCN = {
                "Status": "200",
                "Data": [

                    {
                        "classificationId": 10,
                        "classificationName": "",
                        "courseId": 963,
                        "courseName": "G-技能-2001簽呈寫作訓練(簡中)",
                        "courseTime": "2016/11/09 <br>09:00-13:00 ",
                        "courseType": 3,
                        "courseTypeName": "外訓課程(簡中)",
                        "enrollBegin": "2016/09/09",
                        "enrollEnd": "2016/11/03",
                        "sessionId": 85571,
                        "sessionName": "2016-1109信託業務人員職前訓練(4小時)-台北場(外訓包班)(簡中)"
                    },
                    {
                        "classificationId": 10,
                        "classificationName": "",
                        "courseId": 59633,
                        "courseName": "G-技能-2001簽呈寫作訓練(簡中)",
                        "courseTime": "2016/09/07~2016/12/31",
                        "courseType": 4,
                        "courseTypeName": "線上測驗(簡中)",
                        "enrollBegin": "2016/09/09",
                        "enrollEnd": "2016/11/03",
                        "sessionId": 86920,
                        "sessionName": "105下-分行業務-法令遵循自評檢核考試班(簡中)"
                    },
                ],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseName": "G-技能-2001簽呈寫作訓練(英文)",
                    "courseTime": "2016/01/01~2016/12/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 85908,
                    "sessionName": "信託業務人員職前訓練課程(105年)(英文)"
                },
                {
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 28322,
                    "courseName": "G-技能-2001簽呈寫作訓練(英文)",
                    "courseTime": "2016/10/01~2016/10/31(區間內的Mon,Wed,Fri)<br>09:00-17:00 <br>休息時間12:00-13:00",
                    "courseType": 2,
                    "courseTypeName": "教室課程(英文)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86925,
                    "sessionName": "20161019超強記憶創造個人競爭力(網站測試班)(英文)"
                },
                ],
                "ErrorMessage": ""
            };


            // resultTW = { "Status": 200, "Data": [{ "classificationId": 29, "classificationName": "通識", "courseId": 2361, "courseName": "G-技能-2008初階簡報技巧", "courseTime": "2017/12/12 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/07", "enrollEnd": "2017/12/12", "sessionId": 99691, "sessionName": "20171212初階簡報技巧" }, { "classificationId": 0, "classificationName": "", "courseId": 64726, "courseName": "M-領導力-2004跨世代領導：帶領貓型世代的關鍵技巧", "courseTime": "2017/11/11 <br>09:00-17:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/03", "enrollEnd": "2017/11/11", "sessionId": 99689, "sessionName": "20171111跨世代領導：帶領貓型世代的關鍵技巧" }, { "classificationId": 0, "classificationName": "", "courseId": 5614, "courseName": "G-內講-2002內部講師培訓(一天精華版)", "courseTime": "2017/08/15 <br>09:00-17:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/15", "sessionId": 99685, "sessionName": "20170815內部講師訓(人資包班第一梯)test" }, { "classificationId": 0, "classificationName": "", "courseId": 24838, "courseName": "G-語言-1004 英文會話", "courseTime": "2017/08/25~2017/10/27 每1週(區間內的Fri)<br>18:00-20:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/21", "sessionId": 99676, "sessionName": "2017英文課金控週五人資班 " }, { "classificationId": 15, "classificationName": "專業", "courseId": 72404, "courseName": "8/1人力資源管理", "courseTime": "2017/08/25 <br>09:00-12:00 ", "courseType": 3, "courseTypeName": "外訓課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/25", "sessionId": 99680, "sessionName": "8/1人力資源管理" }, { "classificationId": 0, "classificationName": "", "courseId": 272, "courseName": "G-舒壓-1003健康養生講座", "courseTime": "2017/08/28 <br>09:00-14:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/28", "sessionId": 99674, "sessionName": "20170828貴婦級紓壓講座" }, { "classificationId": 0, "classificationName": "", "courseId": 10451, "courseName": "P-廣告行銷-1007說故事行銷", "courseTime": "2017/08/14 <br>09:00-17:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/14", "sessionId": 99677, "sessionName": "20170814說故事行銷(故事王)-test" }, { "classificationId": 25, "classificationName": "自主", "courseId": 72174, "courseName": "G-語言(自主)-100016-超簡單旅遊日語", "courseTime": "2017/12/05 <br>18:00-20:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/12/05", "sessionId": 99671, "sessionName": "20171205超簡單旅遊日語(自主學習課程)" }, { "classificationId": 0, "classificationName": "", "courseId": 2390, "courseName": "G-溝通-2001掌握風格，輕鬆溝通", "courseTime": "2017/10/24 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/10/24", "sessionId": 99669, "sessionName": "20171024掌握風格，輕鬆溝通" }, { "classificationId": 29, "classificationName": "通識", "courseId": 61240, "courseName": "G-技能-3002商業簡報技巧", "courseTime": "2017/08/21 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/07/14", "enrollEnd": "2017/08/21", "sessionId": 99667, "sessionName": "20170821商業簡報技巧(八德)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 2361, "courseName": "G-技能-2008初階簡報技巧", "courseTime": "2017/09/04 <br>09:00-12:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/07/14", "enrollEnd": "2017/09/04", "sessionId": 99666, "sessionName": "20170904初階簡報技巧" }, { "classificationId": -1, "classificationName": "", "courseId": 331, "courseName": "G-測試-1026-勞委會課程測試+Slide課程", "courseTime": "2017/03/15~", "courseType": 7, "courseTypeName": "學程", "enrollBegin": "2017/03/15", "enrollEnd": "", "sessionId": 1431, "sessionName": "20170315-勞委+3sbook+slide課程" }, { "classificationId": -1, "classificationName": "", "courseId": 330, "courseName": "G-測試-1029-3S課程與勞委課程", "courseTime": "2017/03/15~", "courseType": 7, "courseTypeName": "學程", "enrollBegin": "2017/03/15", "enrollEnd": "", "sessionId": 1430, "sessionName": "20170315-3S課程+勞委會課程" }, { "classificationId": 15, "classificationName": "專業", "courseId": 11180, "courseName": "P-證券-1008(外訓) 股務單位人員教育訓練", "courseTime": "2017/09/20 <br>14:00-17:00 ", "courseType": 3, "courseTypeName": "外訓課程", "enrollBegin": "2017/01/10", "enrollEnd": "2017/09/20", "sessionId": 99286, "sessionName": "2017-0920 股務單位人員教育訓練" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64901, "courseName": "G-成長-1005珍愛一世情─呵護親子關係【MP4-23分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98930, "sessionName": "珍愛一世情-呵護親子關係(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64895, "courseName": "G-技能-1014遠離開會地獄—「開會一把罩」【MP4-32分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98907, "sessionName": "遠離開會地獄—「開會一把罩」(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64891, "courseName": "G-執行力-1003使命必達－淺談目標管理【MP4-23分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98921, "sessionName": "使命必達－淺談目標管理(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64889, "courseName": "G-成長-1006認識太極拳【MP4-12分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98943, "sessionName": "認識太極拳(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64888, "courseName": "G-成長-1007認識國標舞【MP4-17分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98942, "sessionName": "認識國標舞(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64886, "courseName": "G-成長-1010辦公室健康操【MP4-11分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98938, "sessionName": "辦公室健康操(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64877, "courseName": "G-成長-1003吃出健康【MP4-18分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98933, "sessionName": "吃出健康(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64869, "courseName": "G-溝通-1010打造職場好形象【MP4-22分鐘】(v.3)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98945, "sessionName": "打造職場好形象(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 55764, "courseName": "P-專業知識(信用卡)-1005信用卡進件流程與徵審作業介紹(v.3)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98975, "sessionName": "信用卡進件流程與徵審作業介紹(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 29872, "courseName": "P-專業知識(信用卡)-1006信用卡業務管理規範(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98976, "sessionName": "信用卡業務規範(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 18025, "courseName": "G-政策-1009IDP員工職涯發展計畫(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98977, "sessionName": "IDP員工職涯發展計畫(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13951, "courseName": "G-技能-2008【OFFICE2010】ECXEL進階應用（下）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98974, "sessionName": "Excel 2010進階應用（下）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13950, "courseName": "G-技能-2007【OFFICE2010】ECXEL進階應用（上）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98973, "sessionName": "Excel 2010進階應用（上）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13949, "courseName": "G-技能-2006【OFFICE2010】Word 2010進階應用（下）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98972, "sessionName": "Word 2010進階應用（下）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13948, "courseName": "G-技能-2005【OFFICE2010】Word 2010進階應用（上）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98971, "sessionName": "Word 2010進階應用（上）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13939, "courseName": "G-技能-1021【OFFICE2010】OUTLOOK人脈管理王(下)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98970, "sessionName": "OUTLOOK人脈管理王(下)【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13903, "courseName": "G-技能-1020【OFFICE2010】OUTLOOK人脈管理王(上)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98969, "sessionName": "OUTLOOK人脈管理王(上)【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13901, "courseName": "G-技能-1019【OFFICE2010】POWERPOINT創意簡報王", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98968, "sessionName": "POWERPOINT創意簡報王【106年】" }, { "classificationId": 15, "classificationName": "專業", "courseId": 34, "courseName": "P-保險-2003投資型保險證照─年金考試班", "courseTime": "2017/01/04~2017/12/31", "courseType": 4, "courseTypeName": "線上測驗", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98952, "sessionName": "投資型保險證照-年金考試班(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 20266, "courseName": "內部講師調查問券", "courseTime": "2012/08/16~2017/08/31", "courseType": 6, "courseTypeName": "問卷", "enrollBegin": "2012/08/16", "enrollEnd": "2017/08/31", "sessionId": 24543, "sessionName": "2012內部講師調查問卷" }, { "classificationId": 29, "classificationName": "通識", "courseId": 17954, "courseName": "頂峰訓練課前問卷調查", "courseTime": "2012/05/31~2017/11/01", "courseType": 6, "courseTypeName": "問卷", "enrollBegin": "2012/05/31", "enrollEnd": "2017/11/01", "sessionId": 21085, "sessionName": "2012頂峰客戶關係經營課前問卷" }], "ErrorMessage": "" }
            // resultCN = {"Status":200,"Data":[{"classificationId":29,"classificationName":"通識","courseId":13938,"courseName":"G-技能-1018【OFFICE2010】ECXEL精算大師(下)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"线上课程","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98965,"sessionName":"ECXEL精算大師(下)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":13900,"courseName":"G-技能-1017【OFFICE2010】ECXEL精算大師(上)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"线上课程","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98964,"sessionName":"ECXEL精算大師(上)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":68275,"courseName":"G-成長-100002-食得健康，食在安心","courseTime":"2017/03/08 <br>01:00-23:00 ","courseType":2,"courseTypeName":"教室课程","enrollBegin":"2016/10/03","enrollEnd":"2018/10/04","sessionId":99381,"sessionName":"食的健康(复制)错误测试_相同上课时间"}],"ErrorMessage":""}
            // resultUS = {"Status":200,"Data":[{"classificationId":29,"classificationName":"通識","courseId":13937,"courseName":"G-技能-1016【OFFICE2010】WORD文書排版(下)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"Online course","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98963,"sessionName":"WORD文書排版(下)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":41109,"courseName":"G-新人-1033Welcome to Taishin【SG】","courseTime":"2014/08/22~2017/10/31","courseType":1,"courseTypeName":"Online course","enrollBegin":"2014/08/22","enrollEnd":"2017/10/31","sessionId":54667,"sessionName":"Welcome to Taishin【SG】(test)"}],"ErrorMessage":""}


            switch (params.LanguageCode) {
                case "en-US":
                    result = resultUS;
                    break;
                case "zh-CN":
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            result.Data = _.filter(result.Data, function (item) {
                item.classificationId = parseInt(item.classificationId);
                var compareClassficationId = parseInt(params.ClassificationId) ;
                // console.log('item.classificationId:',item.classificationId);
                // console.log('compareClassficationId:',compareClassficationId);
                // if (!compareClassficationId) {
                //     compareClassficationId = -1;
                // }
                if (compareClassficationId === -1) {
                    compareClassficationId = item.classificationId;
                }

                return (item.classificationId === compareClassficationId);
            });
            return { data: result };
        }


        /**
         * 6.取得課程詳細內容
         * @returns
         */
        function CourseSession(type) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var CourseSessionType1; /* 線上課程 */
            var CourseSessionType2; /* 教室課程 */
            var CourseSessionType3; /* 外訓 */
            var CourseSessionType4; /* 線上測驗 */
            var CourseSessionType5; /* 教室測驗 */
            var CourseSessionType6; /* 問卷 */
            var CourseSessionType7; /* 學程 */
            CourseSessionType1 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "1.最低稅負制溫故知新98進化版【29分鐘】 \r\n2.經濟基本指標【57分鐘】 \r\n3.投資境外結構型商品前的基本概念【33分鐘】 \r\n4.債券市場理論與實務【27分鐘】 \r\n5.保本及非保本型商品【41分鐘】 \r\n6.風險型態與分析【11分鐘】 \r\n7.衍生性金融商品法規介紹【29分鐘】 \r\n8.結構型商品參考法規─境外結構型商品相關【35分鐘】 \r\n9.有價證券信託【14分鐘】 \r\n10.雙雙得利投資帳戶【46分鐘】 \r\n11.SDS系統介紹【14分鐘】 \r\n12.組合式商品介紹【52分鐘】 \r\n13.組合式商品(SI/DCI/ELI)稅賦說明【30分鐘】 \r\n14.TIPS信託投資系統操作說明【102分鐘】 \r\n15.TRMS系統說明【16分鐘】 \r\n16.共同基金銷售關鍵資訊【63分鐘】 \r\n17.共同基金銷售關鍵資訊【課後測驗】 \r\n18.境內外基金相關法令【100分鐘】 \r\n19.規劃行信託相關法規簡介【21分鐘】",
                    "duration": 720,
                    "enrollCount": 11,
                    "enrollPeriod": "2017/01/04~2017/06/30",
                    "enrollRemain": 5,
                    "enrollTime": "2017/01/04~2017/06/30",
                    "outline": "1.最低稅負制溫故知新98進化版【29分鐘】 \r\n2.經濟基本指標【57分鐘】 \r\n3.投資境外結構型商品前的基本概念【33分鐘】 \r\n4.債券市場理論與實務【27分鐘】 \r\n5.保本及非保本型商品【41分鐘】 \r\n6.風險型態與分析【11分鐘】 \r\n7.衍生性金融商品法規介紹【29分鐘】 \r\n8.結構型商品參考法規─境外結構型商品相關【35分鐘】 \r\n9.有價證券信託【14分鐘】 \r\n10.雙雙得利投資帳戶【46分鐘】 \r\n11.SDS系統介紹【14分鐘】 \r\n12.組合式商品介紹【52分鐘】 \r\n13.組合式商品(SI/DCI/ELI)稅賦說明【30分鐘】 \r\n14.TIPS信託投資系統操作說明【102分鐘】 \r\n15.TRMS系統說明【16分鐘】 \r\n16.共同基金銷售關鍵資訊【63分鐘】 \r\n17.共同基金銷售關鍵資訊【課後測驗】 \r\n18.境內外基金相關法令【100分鐘】 \r\n19.規劃行信託相關法規簡介【21分鐘】",
                    "reference": [{
                        "fileExt": "PDF 文件",
                        "name": "共同基金銷售關鍵資訊-熟知KYC、KYP，與客戶共贏",
                        "path": "Storage\\Reference\\2703\\2126340124-1482803634927.pdf"
                    }],
                    "sessionName": "信託業務人員在職訓練課程(106上半年)",
                    "sessionTime": "2017/01/04 ~ 2017/06/30",
                    "target": "登錄信託公會者，每三年複訓完成本課程",
                    "waitlistCount": 5,
                    "waitlistRemain": 100
                },
                "ErrorMessage": ""
            };
            CourseSessionType2 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 500,
                    "description": "",
                    "enrollCount": 0,
                    "enrollRemain": 45,
                    "enrollTime": "2016/10/03~2018/10/04",
                    "hours": 22,
                    "intructors": "蔡毓昇 (840117)<BR>林以君 (914293)",
                    "outline": "1. 喝水喝對了嗎?\r\n2. 餐具用對了嗎?\r\n3. 容器用對了嗎?\r\n4. 增強免疫力你做對了嗎?\r\n5. Q & A",
                    "place": "內湖大樓203會議室",
                    "reference": [],
                    "sessionName": "食的健康(複製)錯誤測試_相同上課時間",
                    "sessionTime": "2017/03/08 <br>01:00-23:00 ",
                    "target": "",
                    "trainingPoint": 0,
                    "waitlistCount": 100,
                    "waitlistRemain": 100
                },
                "ErrorMessage": ""
            };
            CourseSessionType3 = {
                "Status": "200",
                "Data": {
                    "division": "信託公會(請直接至課程中報名，費用統一由HR月結支付)",
                    "enrollCount": 1,
                    "enrollPeriod": "2016/12/27~2017/04/22",
                    "externalType": "一般外訓",
                    "hours": 6,
                    "note": "來上課",
                    "outline": "1.各金融機構信託業業務人員\r\n2.財富管理相關業務人員",
                    "ownCost": 0,
                    "place": "台中市文心路二段645號11樓(新光人壽惠國大樓)   ",
                    "reference": [{
                        "fileExt": "pdf",
                        "name": "1.pdf",
                        "path": "Storage\\CTMSReference\\918\\547400339-1487310466496.pdf"
                    }],
                    "sessionTime": "2017/04/22 <br>09:00-16:00 <br>休息時間12:00-13:00",
                    "subsidyCost": 1300,
                    "totalCost": 1300
                },
                "ErrorMessage": ""
            };
            CourseSessionType4 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "測試用",
                    "duration": 30,
                    "enrollCount": 2,
                    "enrollPeriod": "2017/02/22~2017/03/20",
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/22~2017/03/20",
                    "outline": "",
                    "reference": [],
                    "sessionName": "20170222(測試班)",
                    "sessionTime": "2017/02/22 ~ 2017/03/20",
                    "target": "測試用",
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType5 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "",
                    "enrollCount": 5,
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/18~2017/05/12",
                    "hours": 1,
                    "intructors": "內部講師",
                    "outline": "",
                    "place": "文心分行3樓",
                    "reference": [],
                    "sessionName": "20170512徵信照會證照研習班 (補考) ",
                    "sessionTime": "2017/05/12 <br>09:00-10:00 ",
                    "target": "",
                    "trainingPoint": 0,
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType6 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "TEST",
                    "duration": -1,
                    "enrollCount": 2,
                    "enrollPeriod": "2017/02/17~2017/06/30",
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/17~2017/06/30",
                    "outline": "",
                    "reference": [{
                        "fileExt": "PDF 文件",
                        "name": "1",
                        "path": "Storage\\Reference\\2767\\-1480076052-1487315027958.pdf"
                    }],
                    "sessionName": "2017問卷測試",
                    "sessionTime": "2017/02/17 ~ 2017/06/30",
                    "target": "對象",
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType7 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "courses": [{
                        "courseId": 45,
                        "courseName": "G-政策-100002-eMBO系統-績效目標設定(v.1)",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 1,
                        "sessionId": 99349
                    },
                    {
                        "courseId": 3366,
                        "courseName": "G-政策-1008eMBO系統-職場行為調整",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 2,
                        "sessionId": 99350
                    },
                    {
                        "courseId": 9280,
                        "courseName": "G-政策-1020IDP員工職涯發展計畫-介紹篇",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 3,
                        "sessionId": 99351
                    }
                    ],
                    "description": "本學程共有三門課程，每門課程需閱讀達90%以上，始得通過。\r\n1. eMBO系統-績效目標設定：15分鐘\r\n2. eMBO系統-職場行為調整：6分鐘\r\n3. IDP員工職涯發展計畫-介紹篇：6分鐘 ",
                    "enrollCount": 0,
                    "enrollRemain": 10,
                    "enrollTime": "2017/02/17~2017/06/30",
                    "sessionName": "學程2017年測試",
                    "sessionTime": "2017/02/17 ~ 2017/06/30",
                    "target": "MA"
                },
                "ErrorMessage": ""
            };
            switch (type) {
                case enumCourseType.webCourse:
                    result = CourseSessionType1;
                    break;
                case enumCourseType.classCourse:
                    result = CourseSessionType2;
                    break;
                case enumCourseType.externalCourse:
                    result = CourseSessionType3;
                    break;
                case enumCourseType.webTest:
                    result = CourseSessionType4;
                    break;
                case enumCourseType.classTest:
                    result = CourseSessionType5;
                    break;
                case enumCourseType.questList:
                    result = CourseSessionType6;
                    break;
                case enumCourseType.courage:
                    result = CourseSessionType7;
                    break;
                default:
                    result = { Status: 400, ErrorMessage: "未知的課程類型" };
                    break;
            }
            return { data: result };
        }

        /**
         * 7.取得課程測驗內容
         * @returns
         */
        function ExamSurveyContent(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTestData1 = {
                "Status": "200",
                "Data": {
                    "examHistoryId": 1515029,
                    "itemId": 175226,
                    "limitMins": -1,
                    "limitTimes": 1,
                    "remainingMins": 1642,
                    "remainingTimes": 4,
                    "questions": [{
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42109,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我明確知道我在這個課程要學習到什麼。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": "true"
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": "true"
                        }
                        ],
                        "questionId": 42110,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容架構清晰、具邏輯且份量適中。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": "true"
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42111,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容完整、具正確性並符合我的學習程度。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42112,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程的表現方式(如文字、圖片、動畫、影像、聲音…等)能有效傳達學習內容。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42113,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程學習介面(如字型、組成、配置、呈現方式…等)能有效呈現學習內容。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42120,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程提供清晰、適切的學習導引功能(如：向前、後退、回主選單、離開…)，並且容易操作與使用。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "2",
                            "value": ""
                        }
                        ],
                        "questionId": 42114,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "系統所提供的網路頻寬與連線服務是足夠的。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "這是選項5，假定有勾選",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "這是選項4，假定有勾選",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "這是選項3，假定沒勾選",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "這是選項2，假定沒勾選",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "這是選項1，假定有勾選",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 6,
                            "title": "這是選項6，假定有勾選",
                            "type": "2",
                            "value": ""
                        }
                        ],
                        "questionId": 42115,
                        "questionType": 2,
                        "required": true,
                        "scoreRate": 0,
                        "title": "這是複選題，用以測試是否運作正常。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42121,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課後測驗能幫助我學習，並能讓我知道是否有學習到應該習得的。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42116,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程有達到我的期望。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42117,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容對我的工作是有幫助的。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42118,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我對人力資源處訓練發展組提供的 e-Learning 課程服務感到滿意。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 42119,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我會向其他同仁推薦此課程。{是必選題，題目序號後面應有標示提醒}"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": " ",
                            "type": "3",
                            "value": "AAATE"
                        }],
                        "questionId": 42122,
                        "questionType": 3,
                        "required": false,
                        "scoreRate": 0,
                        "title": "如有其他相關建議，請填寫在下面空白處，謝謝！{不是必選題}"
                    }
                    ]
                },
                "ErrorMessage": ""
            };
            var resultTestData2 = {
                "Status": "200",
                "Data": {
                    "examHistoryId": 1515312,
                    "itemId": 306761,
                    "limitMins": 30,
                    "limitTimes": 3,
                    "remainingMins": -1,
                    "remainingTimes": 6,
                    "questions": [{
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88414,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "事業銷售商品或服務附送贈品，其贈品價值上限為：商品或服務價值在新臺幣100元以上者，為商品或服務價值之二分之一；商品或服務價值在新臺幣100元以下者，為新臺幣50元。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88381,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理財富管理業務或對非財富管理部門客戶銷售金融商品，不得以提供贈品方式招攬新客戶開立存款帳戶，以免違反銀行法第34條之規定，至其餘贈品活動仍須遵守銀行公會會員自律公約之相關規定。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "銷售投資型保險商品予客戶時不得任意銷售風險過高、結構過於複雜之商品。但有客觀事實證明客戶有相當專業認識及風險承擔能力者，不在此限。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "就非專業投資人之年齡、對本商品相關知識、投資經驗、財產狀況、交易目的及商品理解等要素，綜合評估其風險承受能力，無須分級，只需要保人簽名確認即可。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "應請客戶提供相關財務資訊，若客戶拒絕提供，招攬人員須於要保書予以註記，並請其於註記處親自簽名確認。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "如係連結結構型商品者，另應提供客戶投資報酬與風險告知書、結構型商品中文產品說明書及中文投資人須知。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88387,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "下列關於投資型保險商品銷售應注意事項之敘述，何者正確?(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88403,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業提供投資型金融商品或服務前，應依各類金融商品或服務之特性評估金融商品或服務對金融消費者之適合度。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "該境外結構型商品因利率、匯率、有價證券市價或其他指標之變動，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "該境外結構型商品因發行機構或他人之業務或財產狀況之變化，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "該境外結構型商品因其他經主管機關規定足以影響投資人判斷之重要事項，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "受託或銷售機構就前項境外結構型商品受託投資、受託買賣或以之為投資型保單投資標的，涉有契約權利行使期間、解除期間及效力之限制者。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88392,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "依據境外結構型商品管理規則，下列何者為受託或銷售機構受託投資，受託買賣境外結構型商品或以之為投資型保單投資標的前，應向投資人說明之事項?(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "金融消費者資金操作狀況及專業能力。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "金融消費者之投資屬性、對風險之瞭解及風險承受度。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "金融消費者服務之合適性，合適之投資建議範圍。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "金融消費者之所得與資金來源。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88419,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業提供投資型金融商品或服務，於訂立契約前，應充分瞭解金融消費者之相關資料，其內容至少應包括下列何者事項？(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "客戶風險屬性與商品風險屬性不適配時，銀行仍宜與客戶進行交易。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "對於高齡、教育水準較低等弱勢族群客戶，基於風險承擔能力及商品適合度考量，銀行應避免與此類客戶承作結構型商品交易，以減少交易糾紛。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "客戶承作雙元貨幣等不保本之結構型商品之金額占其往來資金比率較高者，銀行宜主動提醒客戶相關商品之風險，避免客戶因投資部位過度集中而蒙受重大損失。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "得以存款名義銷售。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88382,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "下列何者為銀行辦理結合存款與衍生性金融商品之結構型商品業務時，應留意之事項?(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "對金融消費者所負擔義務不得低於廣告之內容。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "對金融商品或服務內容之揭露如涉及利率、費用、報酬及風險時，應以衡平及顯著之方式表達。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "應忠於原著，以英文表達，必要時得附註中文。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "應以金融服務業名義為之。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88405,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "金融服務業從事廣告、業務招攬及營業促銷活動，應遵守哪些原則?(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88406,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "境外結構型商品之投資人須知之重要內容，應以錄音方式保留紀錄。但對專業投資人得以交付書面或影音媒體方式取代。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88401,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業有關外匯業務之經營，除銀行業辦理外匯業務管理辦法或央行另有規定者外，應向央行申請許可，並經發給指定證書或許可函後，始得辦理。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88388,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "最近一期經會計師查核或核閱之財務報告總資產超過新臺幣5000萬元之法人或基金，為境外結構型商品管理規則中所規定之專業投資人。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88389,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "於銷售投資型保險商品時，應審酌被保險人年齡等情況予以推介或銷售適當之商品，當被保險人投保時之保險年齡大於或等於70或本商品連結有結構型商品且被保險人於該結構型商品期滿時之保險年齡大於或等於70時，應請要保人及被保險人於要保書中之重要事項告知書或「結構型債券投資報酬與風險告知書」簽名已瞭解並願意承擔投資風險，如要保人及被保險人不願填寫則仍同意其投保。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "不得以吸收存款為目的。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "應按業務類別，分別適用各該業務法令規定及自律規範。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "贈品之單一價格以新臺幣一千元內為宜。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "銀行得為維持與客戶關係、其他業務推展或企業形象宣導等非吸收存款目的，舉辦與存款業務有關之贈品業務推廣活動。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88418,
                        "questionType": 1,
                        "required": false,
                        "scoreRate": 5,
                        "title": "關於銀行業辦理與存款業務有關之贈品贈獎業務推廣活動時應遵循之規定，以下何者為非？"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88383,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理財富管理業務，應請切實注意以誠信及充分揭露原則辦理，廣告文宣中就金融商品之可能報酬、風險及限制條件之揭露，應以衡平且顯著方式表達，不得有誇大不實陳述或誤導消費者之虞情事。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "除法令另有規定外，行銷廣告文件於對外使用前應經法令遵循主管審核。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "得使人相信能保證本金之安全或獲利。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "對於獲利與風險應作平衡報導，且得載有與向主管機關申請文件內容不符之文字或設計。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "特定投資標的之名稱應適當表達其特性及風險，不得使用可能誤導客戶之名稱。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88397,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "信託業辦理營業促銷活動時，應遵守下列何項規定？(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88416,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "「銀行辦理衍生性金融商品自律規範」所稱以錄音方式保留向一般客戶宣讀結構型商品交易客戶須知之重要內容，交易遇有爭議，不必保留至爭議終結為止。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "任何說明或揭露之資訊或資料均須正確。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "所有銷售文件無須編印頁碼。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 3,
                            "title": "銷售文件之用語應以中文表達，並力求淺顯易懂，必要時得附註原文。",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 4,
                            "title": "應本於誠實信用原則，並以金融消費者能充分瞭解之文字或其他方式為之。",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88409,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "金融服務業說明金融商品或服務契約之重要內容及揭露風險，應遵守哪些基本原則?(複選題)"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88398,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理外幣保證金交易及組合式產品等業務，應制定與落實瞭解客戶（KYC ）原則，並充分揭露相關風險，不得有誤導客戶情事。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        },
                        {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }
                        ],
                        "questionId": 88386,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行依據「銀行辦理衍生性金融商品自律規範」錄音或錄影所留存之個人資料，任何人均得於保存期限內，向銀行申請調閱。除該資料之提供有妨害銀行或第三人之重大利益外，銀行應配合提供前項紀錄，並得向當事人收取必要成本費用。"
                    },
                    {
                        "attachment": "",
                        "groupName": "",
                        "options": [
                            // {
                            //     "attachment": "",
                            //     "order": 1,
                            //     "title": "是",
                            //     "type": "1",
                            //     "value": ""
                            // },
                            // {
                            //     "attachment": "",
                            //     "order": 2,
                            //     "title": "否",
                            //     "type": "1",
                            //     "value": ""
                            // },
                            {
                                "attachment": "",
                                "correctAnswer": false,
                                "order": 1,
                                "preTitle": false,
                                "textValue": "",
                                "title": " ",
                                "type": "3",
                                "value": "HR網站→台新大學→訓練中心"
                            }
                        ],
                        "questionId": 88400,
                        "questionType": 3,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業經主管機關命其於一定期間內停止申辦外匯業務，於停止期間尚未屆滿或未提報適當之具體改善措施，或提報之改善措施未獲主管機關認可前，不得以函報備查方式開辦依本辦法規定得函報備查之外匯業務。"
                    },


                    ]
                },
                "ErrorMessage": ""
            };
            // console.log(params);
            switch (params.type) {
                case '問卷':
                    result = resultTestData1;
                    break;
                case '測驗':
                    result = resultTestData2;
                    break;
                default:
                    result = { Status: 400, Data: null, ErrorMessage: "未知的課程類型" };
            }
            return { data: result };
        }
        /**
         * 8.測驗結果(P.7~8)
         * @returns
         */
        function InteractionData(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTestData1Answer = {
                "Status": "200",
                "Data": null,
                "ErrorMessage": ""
            };
            var resultTestData2Answer = {
                "Status": "200",
                "Data": {
                    "questionResults": [{
                        "correctAnswer": "1,2,3,4",
                        "questionId": 88419,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "3",
                        "questionId": 88418,
                        "studentAnswer": "x"
                    },
                    {
                        "correctAnswer": "2",
                        "questionId": 88416,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1",
                        "questionId": 88414,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1,3,4",
                        "questionId": 88409,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "",
                        "questionId": 88406,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1,2,4",
                        "questionId": 88405,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1",
                        "questionId": 88403,
                        "studentAnswer": "2"
                    },
                    {
                        "correctAnswer": "",
                        "questionId": 88401,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "HR網站→台新大學→訓練中心",
                        "questionId": 88400,
                        "studentAnswer": "asd"
                    },
                    {
                        "correctAnswer": "1",
                        "questionId": 88398,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1,4",
                        "questionId": 88397,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1,2,3,4",
                        "questionId": 88392,
                        "studentAnswer": "x"
                    },
                    {
                        "correctAnswer": "2",
                        "questionId": 88389,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "",
                        "questionId": 88388,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1,3,4",
                        "questionId": 88387,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "",
                        "questionId": 88386,
                        "studentAnswer": "2"
                    },
                    {
                        "correctAnswer": "1",
                        "questionId": 88383,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "2,3",
                        "questionId": 88382,
                        "studentAnswer": "1"
                    },
                    {
                        "correctAnswer": "1",
                        "questionId": 88381,
                        "studentAnswer": "1"
                    }
                    ],
                    "right": 0,
                    "score": 0,
                    "totalQuestions": 20,
                    "wrong": 20
                },
                "ErrorMessage": ""
            };
            // console.log("params:", params);
            switch (params.type) {
                case '問卷':
                    result = resultTestData1Answer;
                    break;
                case '測驗':
                    result = resultTestData2Answer;
                    break;
                default:
                    result = { Status: 400, Data: null, ErrorMessage: "未知的課程類型" };
            }
            return { data: result };
        }


        /**
         * 11.待修課程列表
         * @returns
         */
        function MyUnfinishedActivities(params) {
            return new Promise((resolve, reject) => {
                var result = {
                    Status: 0,
                    Data: {},
                    ErrorMessage: ""
                };
                var resultTW;
                var resultCN;
                var resultUS;

                resultTW = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 69435,
                        "courseType": 4,
                        "courseTypeName": "線上測驗",
                        "enrollmentId": 2165989,
                        "progress": "0/1",
                        "sessionId": 99354,
                        "sessionName": "20170512徵信照會證照研習班 (補考) ",
                        "sessionTime": "2017/05/12 <br>09:00-10:00 ",
                        "status": "未曾觀看"
                    },
                    {
                        "courseId": 67418,
                        "courseType": 3,
                        "courseTypeName": "外訓",
                        "enrollmentId": 2165984,
                        "progress": "0/1",
                        "sessionId": 99353,
                        "sessionName": "20170306北區對保實務研習班 (補考)",
                        "sessionTime": "2017/03/06 <br>09:00-10:00 ",
                        "status": "待修中"
                    },
                    {
                        "courseId": 10790,
                        "courseType": 5,
                        "courseTypeName": "教室測驗",
                        "enrollmentId": 2165972,
                        "progress": "0/1",
                        "sessionId": 99207,
                        "sessionName": "20170302Oracle PL/SQL認證測驗 ",
                        "sessionTime": "2017/03/02 <br>10:00-12:00 ",
                        "status": "待修中"
                    },
                    {
                        "courseId": 61240,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165974,
                        "progress": "1/2",
                        "sessionId": 99345,
                        "sessionName": "20170420商業簡報技巧(八德)",
                        "sessionTime": "2017/04/20 <br>09:00-12:00 ",
                        "status": "未完成"
                    },
                    {
                        "courseId": 9330,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165973,
                        "progress": "1/2",
                        "sessionId": 95401,
                        "sessionName": "20170417簡報製作技巧(2010版)",
                        "sessionTime": "2017/04/17 <br>13:30-17:30 ",
                        "status": "等待簽核中"
                    },
                    {
                        "courseId": 71771,
                        "courseType": 6,
                        "courseTypeName": "線上問卷",
                        "enrollmentId": 2165970,
                        "progress": "1/20",
                        "sessionId": 98593,
                        "sessionName": "信託業務人員在職訓練課程(106上半年)",
                        "sessionTime": "2017/01/04~2017/06/30",
                        "status": "未完成"
                    },
                    {
                        "courseId": 2361,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165963,
                        "progress": "1/2",
                        "sessionId": 98736,
                        "sessionName": "20170308初階簡報技巧",
                        "sessionTime": "2017/03/08 <br>13:30-17:30 ",
                        "status": "未完成"
                    },
                    {
                        "courseId": 71776,
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "enrollmentId": 2165962,
                        "progress": "0/3",
                        "sessionId": 98600,
                        "sessionName": "信託在職-組合式商品簡介 (106上半年)",
                        "sessionTime": "2017/01/04~2017/06/30",
                        "status": "未完成"
                    },
                    {
                        "courseId": 64877,
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "enrollmentId": 2165961,
                        "progress": "0/2",
                        "sessionId": 98933,
                        "sessionName": "吃出健康(106年)",
                        "sessionTime": "2017/01/04~2017/12/31",
                        "status": "未完成"
                    },
                    {
                        "courseId": 0,
                        "courseType": 7,
                        "courseTypeName": "學程",
                        "enrollmentId": 2165976,
                        "progress": "",
                        "sessionId": 99286,
                        "sessionName": "2017-0920 股務單位人員教育訓練",
                        "sessionTime": "~",
                        "status": "等待簽核中"
                    },
                    {
                        "courseId": 0,
                        "courseType": 7,
                        "courseTypeName": "學程",
                        "enrollmentId": 2165975,
                        "progress": "",
                        "sessionId": 98652,
                        "sessionName": "2017-0422信託業務人員在職訓練-台中場",
                        "sessionTime": "~",
                        "status": "等待簽核中"
                    }
                    ],
                    "ErrorMessage": ""
                };
                resultCN = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 66903,
                        "courseType": 1,
                        "courseTypeName": "線上課程(簡中)",
                        "enrollmentId": 1975394,
                        "progress": "0/3",
                        "sessionId": 91423,
                        "sessionName": "理專APP功能操作與使用(test)(簡中)",
                        "sessionTime": "2016/07/25~2016/12/31",
                        "status": "未完成(簡中)"
                    },
                    {
                        "courseId": 963,
                        "courseType": 3,
                        "courseTypeName": "外訓課程(簡中)",
                        "enrollmentId": 2118844,
                        "progress": "0/2",
                        "sessionId": 93496,
                        "sessionName": "20161231信託業務人員職前訓練(4小時)-台北場(簡中)",
                        "sessionTime": "2016/12/31 <br>13:00-17:00 ",
                        "status": "待修中(簡中)"
                    }
                    ],
                    "ErrorMessage": ""
                };
                resultUS = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 58954,
                        "courseType": 1,
                        "courseTypeName": "線上課程(英文)",
                        "enrollmentId": 2118839,
                        "progress": "0/1",
                        "sessionId": 96530,
                        "sessionName": "「看見愛的力量」微電影(2016)(英文)",
                        "sessionTime": "2016/12/01~2016/12/31",
                        "status": "未完成(英文)"
                    },
                    {
                        "courseId": 305,
                        "courseType": 7,
                        "courseTypeName": "學程(英文)",
                        "enrollmentId": 0,
                        "progress": "0/12",
                        "sessionId": 1356,
                        "sessionName": "新人e起來(105-Q4)(英文)",
                        "sessionTime": "2016/10/01~2016/12/31",
                        "status": "未完成(英文)"
                    },
                    {
                        "courseId": 290,
                        "courseType": 7,
                        "courseTypeName": "學程(英文)",
                        "enrollmentId": 0,
                        "progress": "0/26",
                        "sessionId": 1370,
                        "sessionName": "人身保險業務員在職訓練第一年(2016-V)人身保險業務員在職訓練第一年(2016-V)【含洗錢】(英文)",
                        "sessionTime": "2016/11/01~2016/12/27",
                        "status": "未完成(英文)"
                    }
                    ],
                    "ErrorMessage": ""
                };
                switch (params.LanguageCode) {
                    case 'en-US':
                        result = resultUS;
                        break;
                    case 'zh-CN':
                        result = resultCN;
                        break;
                    default:
                        result = resultTW;
                        break;
                }

                if (params.LanguageCode === 'zh-TW') {
                    setTimeout(function () {
                        resolve({ data: result });
                    }, 1000);
                } else {
                    resolve({ data: result });
                }

            });
        }




        /**
         * 12.修課記錄列表
         * @returns
         */
        function MyFinishedActivities(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTW;
            var resultCN;
            var resultUS;

            resultTW = {
                "Status": "200",
                "Data": [{
                    "courseId": 4,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 161360,
                    "sessionId": 2056,
                    "sessionName": "Acrobat_PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應用(100上半年)",
                    "sessionTime": "2011/01/01~2011/06/30",
                    "status": 3
                },
                {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1012635,
                    "sessionId": 46737,
                    "sessionName": "Time is Money：時間管理(103上半年)",
                    "sessionTime": "2014/01/01~2014/06/30",
                    "status": 3
                },
                {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1854663,
                    "sessionId": 82308,
                    "sessionName": "Time is Money：時間管理(105上半年)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 2
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1765530,
                    "sessionId": 82149,
                    "sessionName": "投資型保險證照-年金考試班(105-01)",
                    "sessionTime": "2016/01/04~2016/01/31",
                    "status": 3
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1852664,
                    "sessionId": 85907,
                    "sessionName": "投資型保險證照-年金考試班(105-04)",
                    "sessionTime": "2016/04/01~2016/04/30",
                    "status": 3
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1955630,
                    "sessionId": 89956,
                    "sessionName": "投資型保險證照-年金考試班(105下半年)",
                    "sessionTime": "2016/07/01~2016/12/27",
                    "status": 2
                },
                {
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 7736,
                    "sessionId": 25,
                    "sessionName": "簡易外匯機制考試班(9910-9912)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 3
                },
                {
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 2089734,
                    "sessionId": 94266,
                    "sessionName": "簡易外匯機制考試班(通路105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 14330,
                    "sessionId": 17,
                    "sessionName": "開戶對保作業實務介紹(9910-9912)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 2
                },
                {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1765452,
                    "sessionId": 82173,
                    "sessionName": "開戶對保作業實務介紹(105-Q1)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                },
                {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2131900,
                    "sessionId": 94261,
                    "sessionName": "開戶對保作業實務介紹(105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 61,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 244471,
                    "sessionId": 7229,
                    "sessionName": "自行查核相關規範及注意事項(100-Q3)",
                    "sessionTime": "2011/07/01~2011/09/30",
                    "status": 2
                },
                {
                    "courseId": 83,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1580993,
                    "sessionId": 74983,
                    "sessionName": "認識國標舞(104下半年)",
                    "sessionTime": "2015/08/04~2015/12/31",
                    "status": 3
                },
                {
                    "courseId": 115,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1782552,
                    "sessionId": 83589,
                    "sessionName": "20160412+0419內部講師培訓 ",
                    "sessionTime": "2016/04/12 <br>09:00-17:00 <br>休息時間12:00-13:00<br><br>2016/04/19 <br>09:00-17:00 <br>休息時間12:00-13:00",
                    "status": 2
                },
                {
                    "courseId": 121,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 218800,
                    "sessionId": 7151,
                    "sessionName": "20110823簽呈寫作訓練",
                    "sessionTime": "2011/08/23 <br>13:30-18:00 ",
                    "status": 2
                },
                {
                    "courseId": 219,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 264566,
                    "sessionId": 8329,
                    "sessionName": "20111011-Fun輕鬆~~創造快樂的生活",
                    "sessionTime": "2011/10/11 <br>14:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 417,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 20519,
                    "sessionId": 639,
                    "sessionName": "防制洗錢，大家一起來！(2010)",
                    "sessionTime": "2010/11/15~2010/11/26",
                    "status": 2
                },
                {
                    "courseId": 440,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 16220,
                    "sessionId": 656,
                    "sessionName": "理專銷售一致化法規檢測(9911)",
                    "sessionTime": "2010/11/11~2010/11/12",
                    "status": 3
                },
                {
                    "courseId": 555,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 16934,
                    "sessionId": 770,
                    "sessionName": "理專銷售一致化法規檢測(題型測試)",
                    "sessionTime": "2010/11/12~2010/11/12",
                    "status": 3
                },
                {
                    "courseId": 1150,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 43260,
                    "sessionId": 1544,
                    "sessionName": "1214講師座談會",
                    "sessionTime": "2010/12/14 <br>14:00-17:30 ",
                    "status": 2
                },
                {
                    "courseId": 1427,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 53226,
                    "sessionId": 1848,
                    "sessionName": "資訊安全教育",
                    "sessionTime": "2011/01/03~2011/01/21",
                    "status": 2
                },
                {
                    "courseId": 1511,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1767571,
                    "sessionId": 82177,
                    "sessionName": "覆核實務作業介紹(通路105-Q1)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                },
                {
                    "courseId": 1684,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 97963,
                    "sessionId": 2348,
                    "sessionName": "員工保密規約測驗 (100-Q1)",
                    "sessionTime": "2011/01/10~2011/03/31",
                    "status": 2
                },
                {
                    "courseId": 1926,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 98474,
                    "sessionId": 2658,
                    "sessionName": "資訊安全教育(問卷補考班)",
                    "sessionTime": "2011/01/31~2011/02/25",
                    "status": 2
                },
                {
                    "courseId": 2353,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 115681,
                    "sessionId": 3672,
                    "sessionName": "20110401改變的力量(下午場)",
                    "sessionTime": "2011/04/01 <br>14:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 2759,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 111186,
                    "sessionId": 3622,
                    "sessionName": "當幸福來敲門【此為第一季台新大學宣傳活動，不認列訓練時數】",
                    "sessionTime": "2011/04/14~2011/04/20 每1週(區間內的Mon,Tue,Wed,Thu,Fri)<br>16:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 3062,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 121338,
                    "sessionId": 4155,
                    "sessionName": "1000329測試",
                    "sessionTime": "2011/03/29~2011/03/29",
                    "status": 3
                },
                {
                    "courseId": 3366,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 137379,
                    "sessionId": 4842,
                    "sessionName": "eMBO系統-職場行為調整 (一般同仁)-功能單位、法金",
                    "sessionTime": "2011/04/18~2011/04/29",
                    "status": 2
                },
                {
                    "courseId": 3620,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 147507,
                    "sessionId": 4928,
                    "sessionName": "100年理專專業檢測測驗班(補考班) ",
                    "sessionTime": "2011/04/22~2011/04/22",
                    "status": 3
                },
                {
                    "courseId": 3921,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 157915,
                    "sessionId": 5504,
                    "sessionName": "覆核實務-小百科(5)",
                    "sessionTime": "2011/05/04~2011/06/17",
                    "status": 3
                },
                {
                    "courseId": 4033,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 166491,
                    "sessionId": 5669,
                    "sessionName": "無三不成禮",
                    "sessionTime": "2011/05/13~2011/06/17",
                    "status": 2
                },
                {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 172835,
                    "sessionId": 5598,
                    "sessionName": "201110525體驗學習教學技巧分享",
                    "sessionTime": "2011/05/25 <br>13:30-17:30 ",
                    "status": 2
                },
                {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1165246,
                    "sessionId": 57327,
                    "sessionName": "20140903破冰手法大解析(優秀內部講師免費活動)",
                    "sessionTime": "2014/09/03 <br>13:30-17:30 ",
                    "status": 2
                },
                {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1576652,
                    "sessionId": 74912,
                    "sessionName": "20150922我的熱情來自於成就他人",
                    "sessionTime": "2015/09/22 <br>15:00-18:00 ",
                    "status": 2
                },
                {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 2050891,
                    "sessionId": 93035,
                    "sessionName": "20160930國際大師的創意教學技法與學習新趨勢",
                    "sessionTime": "2016/09/30 <br>14:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 4259,
                    "courseType": 3,
                    "courseTypeName": "外訓課程",
                    "enrollmentId": 610169,
                    "sessionId": 26912,
                    "sessionName": "2012-0921金融市場常識與職業道德",
                    "sessionTime": "2012/09/21 <br>18:00-20:00 ",
                    "status": 2
                },
                {
                    "courseId": 4365,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 165743,
                    "sessionId": 5911,
                    "sessionName": "OJT-3S把服務做到最好",
                    "sessionTime": "2011/05/17 <br>10:00-10:30 ",
                    "status": 2
                },
                {
                    "courseId": 4366,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 165771,
                    "sessionId": 5912,
                    "sessionName": "OJT-法令遵循及資訊安全宣導",
                    "sessionTime": "2011/05/17 <br>10:30-11:00 ",
                    "status": 2
                },
                {
                    "courseId": 4684,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 191644,
                    "sessionId": 6213,
                    "sessionName": "100上-信用卡-法令遵循自評檢核考試班",
                    "sessionTime": "2011/06/01~2011/06/16",
                    "status": 3
                },
                {
                    "courseId": 5283,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 185889,
                    "sessionId": 6758,
                    "sessionName": "個人資料保護法因應與衝擊認知教育訓練(功能、法金)",
                    "sessionTime": "2011/06/20~2011/07/01",
                    "status": 2
                },
                {
                    "courseId": 8995,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 225227,
                    "sessionId": 8668,
                    "sessionName": "3Sbook，隨時分享簡單、真心、極優的每一刻！(功能、法金)",
                    "sessionTime": "2011/07/29~2011/08/12",
                    "status": 2
                },
                {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 243312,
                    "sessionId": 9185,
                    "sessionName": "20110905-1 派外主管管理須知",
                    "sessionTime": "2011/09/05 <br>14:00-16:00 ",
                    "status": 2
                },
                {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245342,
                    "sessionId": 9420,
                    "sessionName": "20110905-2 薪資制度與稅務處理",
                    "sessionTime": "2011/09/05 <br>16:30-20:30 ",
                    "status": 2
                },
                {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245343,
                    "sessionId": 9422,
                    "sessionName": "20111003 員工招聘任用",
                    "sessionTime": "2011/10/03 <br>17:00-20:00 ",
                    "status": 2
                },
                {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245346,
                    "sessionId": 9426,
                    "sessionName": "20111013 社會保險與員工福利",
                    "sessionTime": "2011/10/13 <br>17:00-20:00 ",
                    "status": 2
                },
                {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 464127,
                    "sessionId": 23026,
                    "sessionName": "20121003 與工會共舞",
                    "sessionTime": "2012/10/03 <br>15:00-18:00 ",
                    "status": 2
                },
                {
                    "courseId": 9680,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 554420,
                    "sessionId": 22225,
                    "sessionName": "產險考照模擬測驗(101下半年)",
                    "sessionTime": "2012/07/01~2012/12/31",
                    "status": 3
                },
                {
                    "courseId": 10817,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 291201,
                    "sessionId": 11764,
                    "sessionName": "20111107內控內稽案例暨法令宣導(人力資源處)",
                    "sessionTime": "2011/11/07 <br>15:30-17:30 ",
                    "status": 2
                },
                {
                    "courseId": 11371,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 288776,
                    "sessionId": 11704,
                    "sessionName": "防制洗錢，大家一起來！(2011-法金、功能)",
                    "sessionTime": "2011/10/31~2011/11/11",
                    "status": 2
                },
                {
                    "courseId": 11371,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 554046,
                    "sessionId": 26829,
                    "sessionName": "防制洗錢，大家一起來！(2012-功能其他單位)",
                    "sessionTime": "2012/10/08~2012/10/25",
                    "status": 2
                },
                {
                    "courseId": 11920,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 306566,
                    "sessionId": 12473,
                    "sessionName": "100-11-分行作業規範測驗",
                    "sessionTime": "2011/11/16~2011/11/29",
                    "status": 2
                },
                {
                    "courseId": 13899,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1963434,
                    "sessionId": 90435,
                    "sessionName": "WORD文書排版(上)【105下半年】",
                    "sessionTime": "2016/07/01~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 13901,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1575469,
                    "sessionId": 74131,
                    "sessionName": "POWERPOINT創意簡報王【104下半年】",
                    "sessionTime": "2015/07/20~2015/12/31",
                    "status": 3
                },
                {
                    "courseId": 14828,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 399071,
                    "sessionId": 17536,
                    "sessionName": "20120413 HR也要懂的行銷之道",
                    "sessionTime": "2012/04/13 <br>15:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 16816,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1677300,
                    "sessionId": 79221,
                    "sessionName": "信託在職─信託業務綜覽【II】(104-11)",
                    "sessionTime": "2015/11/01~2015/11/30",
                    "status": 3
                },
                {
                    "courseId": 16827,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 411826,
                    "sessionId": 18708,
                    "sessionName": "eTag自動儲值專案(功能)",
                    "sessionTime": "2012/05/14~2012/05/25",
                    "status": 2
                },
                {
                    "courseId": 17577,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 435905,
                    "sessionId": 21188,
                    "sessionName": "101上-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2012/06/01~2012/06/15",
                    "status": 2
                },
                {
                    "courseId": 18025,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1971636,
                    "sessionId": 82375,
                    "sessionName": "IDP員工職涯發展計畫(105年)",
                    "sessionTime": "2016/01/04~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 18339,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 617003,
                    "sessionId": 30447,
                    "sessionName": "自行查核相關規範及注意事項(102-Q1)",
                    "sessionTime": "2013/01/01~2013/03/26",
                    "status": 2
                },
                {
                    "courseId": 18536,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 460069,
                    "sessionId": 22961,
                    "sessionName": "個資管理控管機制宣導教育訓練(功能)",
                    "sessionTime": "2012/07/09~2012/07/26",
                    "status": 2
                },
                {
                    "courseId": 20268,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 534576,
                    "sessionId": 24547,
                    "sessionName": "20120918 EQ無礙，未來更high",
                    "sessionTime": "2012/09/18 <br>14:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 20628,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 505062,
                    "sessionId": 25030,
                    "sessionName": "20120830輔銷人員晨會及產品專業度檢測",
                    "sessionTime": "2012/08/30~2012/08/31",
                    "status": 3
                },
                {
                    "courseId": 23101,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 583844,
                    "sessionId": 28326,
                    "sessionName": "Q3晨會TEST",
                    "sessionTime": "2012/11/20~2012/12/31",
                    "status": 3
                },
                {
                    "courseId": 25204,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 623890,
                    "sessionId": 31329,
                    "sessionName": "台新銀行新光三越聯名卡競品權益比較(test)",
                    "sessionTime": "2013/02/01~2013/02/01",
                    "status": 3
                },
                {
                    "courseId": 28808,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 701659,
                    "sessionId": 36017,
                    "sessionName": "防制洗錢，大家一起來！(2013功能、子公司II)",
                    "sessionTime": "2013/05/06~2013/05/21",
                    "status": 2
                },
                {
                    "courseId": 29109,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 744824,
                    "sessionId": 37101,
                    "sessionName": "102上-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2013/06/01~2013/06/15",
                    "status": 2
                },
                {
                    "courseId": 29128,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 710389,
                    "sessionId": 36373,
                    "sessionName": "【空中英語教室】Beating Stress (戰勝壓力)",
                    "sessionTime": "2013/05/16~2013/12/31",
                    "status": 3
                },
                {
                    "courseId": 29355,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 757635,
                    "sessionId": 37097,
                    "sessionName": "台新證券-法遵自評筆試(一般)【102上】",
                    "sessionTime": "2013/06/03~2013/06/26",
                    "status": 2
                },
                {
                    "courseId": 31029,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 771493,
                    "sessionId": 38973,
                    "sessionName": "OJT-法規-第二季法令遵循暨資安宣導",
                    "sessionTime": "2013/06/26 <br>14:00-14:30 ",
                    "status": 2
                },
                {
                    "courseId": 31158,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 781710,
                    "sessionId": 39303,
                    "sessionName": "個人資料保護宣導課程(HR)",
                    "sessionTime": "2013/07/15~2013/07/31",
                    "status": 2
                },
                {
                    "courseId": 32901,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 845845,
                    "sessionId": 42432,
                    "sessionName": "「金融消費者保護法」及其相關子法之重點說明(第一梯次)",
                    "sessionTime": "2013/09/23~2013/10/23",
                    "status": 2
                },
                {
                    "courseId": 33111,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1809577,
                    "sessionId": 84810,
                    "sessionName": "2014人身保險在職訓練-零散",
                    "sessionTime": "~",
                    "status": 3
                },
                {
                    "courseId": 33112,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1809679,
                    "sessionId": 84817,
                    "sessionName": "2014財產保險在職訓練-零散",
                    "sessionTime": "~",
                    "status": 3
                },
                {
                    "courseId": 33529,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 855031,
                    "sessionId": 42842,
                    "sessionName": "OJT-法規-第二季法令遵循暨資安宣導",
                    "sessionTime": "2013/09/25 <br>14:00-14:30 ",
                    "status": 2
                },
                {
                    "courseId": 34014,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1808070,
                    "sessionId": 84282,
                    "sessionName": "信託業務人員職前訓練課程(105-03)",
                    "sessionTime": "2016/03/01~2016/03/31",
                    "status": 3
                },
                {
                    "courseId": 34014,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2041573,
                    "sessionId": 91701,
                    "sessionName": "信託業務人員職前訓練課程(105下半年)",
                    "sessionTime": "2016/08/01~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 34181,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 872125,
                    "sessionId": 43743,
                    "sessionName": "20131009 尋找羅浮宮暗畫",
                    "sessionTime": "2013/10/09 <br>15:30-18:30 ",
                    "status": 2
                },
                {
                    "courseId": 35308,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 909145,
                    "sessionId": 45732,
                    "sessionName": "102下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2013/12/02~2013/12/19",
                    "status": 2
                },
                {
                    "courseId": 36343,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1282161,
                    "sessionId": 61835,
                    "sessionName": "信託業務人員在職訓練課程(103-12)",
                    "sessionTime": "2014/12/01~2014/12/31",
                    "status": 3
                },
                {
                    "courseId": 40306,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 994258,
                    "sessionId": 51698,
                    "sessionName": "OJT-2014第一季資安暨法遵宣導課程名單",
                    "sessionTime": "2014/03/25 <br>14:00-14:30 ",
                    "status": 2
                },
                {
                    "courseId": 40351,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 996178,
                    "sessionId": 51788,
                    "sessionName": "防制洗錢，大家一起來(2014功能、子公司、通路)",
                    "sessionTime": "2014/04/02~2014/04/30",
                    "status": 2
                },
                {
                    "courseId": 40643,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1070380,
                    "sessionId": 52424,
                    "sessionName": "20140618 複訓_勞工安全衛生 (北區_內湖_下午)",
                    "sessionTime": "2014/06/18 <br>14:00-17:00 ",
                    "status": 2
                },
                {
                    "courseId": 41344,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1048766,
                    "sessionId": 53283,
                    "sessionName": "金融專業培訓課程--外匯業務分行篇(國外部TEST)",
                    "sessionTime": "2014/05/16~2014/06/30",
                    "status": 3
                },
                {
                    "courseId": 41558,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1056214,
                    "sessionId": 54076,
                    "sessionName": "美國海外帳戶稅收遵循法(FATCA)介紹【2014】",
                    "sessionTime": "2014/06/03~2014/06/30",
                    "status": 2
                },
                {
                    "courseId": 41933,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1576041,
                    "sessionId": 73482,
                    "sessionName": "台新金控的核心价值(104下半年)",
                    "sessionTime": "2015/07/01~2015/12/31",
                    "status": 2
                },
                {
                    "courseId": 43620,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1131157,
                    "sessionId": 56980,
                    "sessionName": "個資侵害事件之應變程序",
                    "sessionTime": "2014/08/11~2014/08/29",
                    "status": 2
                },
                {
                    "courseId": 45594,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1204691,
                    "sessionId": 60298,
                    "sessionName": "2014 資訊安全教育",
                    "sessionTime": "2014/10/13~2014/10/31",
                    "status": 2
                },
                {
                    "courseId": 45594,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1411546,
                    "sessionId": 69411,
                    "sessionName": "2015 資訊安全教育",
                    "sessionTime": "2015/05/04~2015/05/29",
                    "status": 2
                },
                {
                    "courseId": 47260,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1272749,
                    "sessionId": 62654,
                    "sessionName": "企業倫理",
                    "sessionTime": "2014/12/16~2014/12/31",
                    "status": 2
                },
                {
                    "courseId": 50199,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1387594,
                    "sessionId": 68451,
                    "sessionName": "銀行業防制洗錢及打擊資助恐怖主義注意事項(2015)",
                    "sessionTime": "2015/04/07~2015/04/30",
                    "status": 2
                },
                {
                    "courseId": 52160,
                    "courseType": 6,
                    "courseTypeName": "問卷",
                    "enrollmentId": 1425084,
                    "sessionId": 69695,
                    "sessionName": "台新大學暨人資網站改版問卷調查(test)",
                    "sessionTime": "2015/05/12~2015/05/18",
                    "status": 0
                },
                {
                    "courseId": 52160,
                    "courseType": 6,
                    "courseTypeName": "問卷",
                    "enrollmentId": 1437104,
                    "sessionId": 69903,
                    "sessionName": "台新大學暨人資網站改版問卷調查(2015)",
                    "sessionTime": "2015/05/18~2015/05/29",
                    "status": 2
                },
                {
                    "courseId": 55764,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1765451,
                    "sessionId": 82343,
                    "sessionName": "信用卡進件流程與徵審作業介紹(105上半年)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 1
                },
                {
                    "courseId": 55820,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1547020,
                    "sessionId": 75145,
                    "sessionName": "個資侵害事件之應變程序(2015)",
                    "sessionTime": "2015/08/10~2015/09/07",
                    "status": 2
                },
                {
                    "courseId": 58214,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1641409,
                    "sessionId": 78458,
                    "sessionName": "「金融消費者保護法」及其相關子法之重點說明(2015)",
                    "sessionTime": "2015/10/19~2015/11/13",
                    "status": 2
                },
                {
                    "courseId": 58954,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1672067,
                    "sessionId": 79652,
                    "sessionName": "「看見愛的力量」微電影(2015)",
                    "sessionTime": "2015/11/05~2015/12/31",
                    "status": 2
                },
                {
                    "courseId": 59632,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1700490,
                    "sessionId": 80745,
                    "sessionName": "104下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2015/12/01~2015/12/16",
                    "status": 2
                },
                {
                    "courseId": 63973,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1861689,
                    "sessionId": 87641,
                    "sessionName": "資訊安全教育(2016)",
                    "sessionTime": "2016/05/03~2016/05/31",
                    "status": 2
                },
                {
                    "courseId": 65645,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1923693,
                    "sessionId": 89470,
                    "sessionName": "「票據招商 吸收存款」專案",
                    "sessionTime": "2016/06/20~2016/07/15",
                    "status": 2
                },
                {
                    "courseId": 65916,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1945653,
                    "sessionId": 90607,
                    "sessionName": "金融消費者保護法及公平待客原則(含誠信經營守則、企業倫理)",
                    "sessionTime": "2016/07/04~2016/07/29",
                    "status": 2
                },
                {
                    "courseId": 66903,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1975394,
                    "sessionId": 91423,
                    "sessionName": "理專APP功能操作與使用(test)",
                    "sessionTime": "2016/07/25~2016/07/25",
                    "status": 3
                },
                {
                    "courseId": 66903,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1982705,
                    "sessionId": 91521,
                    "sessionName": "理專APP功能操作與使用",
                    "sessionTime": "2016/07/26~2016/08/26",
                    "status": 3
                },
                {
                    "courseId": 67327,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1984657,
                    "sessionId": 92043,
                    "sessionName": "Hahow好學校 廣告影片測試",
                    "sessionTime": "2016/07/31~2016/08/05",
                    "status": 3
                },
                {
                    "courseId": 67836,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2042239,
                    "sessionId": 93734,
                    "sessionName": "防制洗錢及打擊資助恐怖主義風險評估與管理(2016)",
                    "sessionTime": "2016/09/12~2016/10/07",
                    "status": 2
                },
                {
                    "courseId": 68146,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2033954,
                    "sessionId": 93489,
                    "sessionName": "洗錢防制法解析與案例說明 (2016-test)",
                    "sessionTime": "2016/09/02~2016/09/09",
                    "status": 3
                },
                {
                    "courseId": 70025,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 2118774,
                    "sessionId": 96118,
                    "sessionName": "20161128樂活人生健康講座",
                    "sessionTime": "2016/11/28 <br>18:00-19:00 ",
                    "status": 2
                },
                {
                    "courseId": 70253,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 2136532,
                    "sessionId": 96745,
                    "sessionName": "105下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2016/12/01~2016/12/16",
                    "status": 2
                },
                {
                    "courseId": 137,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 71853,
                    "sessionId": 1223,
                    "sessionName": "分行新人e課程-專業理專(105-Q2)",
                    "sessionTime": "2016/04/01~2016/06/30",
                    "status": 3
                },
                {
                    "courseId": 282,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 69170,
                    "sessionId": 1166,
                    "sessionName": "新人e起來(105-01~105-04)",
                    "sessionTime": "2016/01/01~2016/04/30",
                    "status": 3
                },
                {
                    "courseId": 291,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 77491,
                    "sessionId": 1275,
                    "sessionName": "新人e起來(105-Q3)",
                    "sessionTime": "2016/07/01~2016/09/30",
                    "status": 3
                },
                {
                    "courseId": 305,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81076,
                    "sessionId": 1356,
                    "sessionName": "新人e起來(105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                },
                {
                    "courseId": 312,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81331,
                    "sessionId": 1406,
                    "sessionName": "財產保險業務員在職訓練(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                },
                {
                    "courseId": 314,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81327,
                    "sessionId": 1405,
                    "sessionName": "人身保險業務員在職訓練(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                },
                {
                    "courseId": 315,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81323,
                    "sessionId": 1404,
                    "sessionName": "財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練第一年(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                },
                {
                    "courseId": 316,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81319,
                    "sessionId": 1403,
                    "sessionName": "人身保險業務員在職訓練第一年(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                }
                ],
                "ErrorMessage": ""
            };
            resultCN = {
                "Status": "200",
                "Data": [{
                    "courseId": 4,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 161360,
                    "sessionId": 2056,
                    "sessionName": "Acrobat_PDF全應用(100上半年)(簡中)",
                    "sessionTime": "2011/01/01~2011/06/30",
                    "status": 3
                },
                {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 1012635,
                    "sessionId": 46737,
                    "sessionName": "Time is Money：時間管理(103上半年)(簡中)",
                    "sessionTime": "2014/01/01~2014/06/30",
                    "status": 3
                },
                {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 1854663,
                    "sessionId": 82308,
                    "sessionName": "Time is Money：時間管理(105上半年)(簡中)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 2
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1765530,
                    "sessionId": 82149,
                    "sessionName": "投資型保險證照-年金考試班(105-01)(簡中)",
                    "sessionTime": "2016/01/04~2016/01/31",
                    "status": 3
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1852664,
                    "sessionId": 85907,
                    "sessionName": "投資型保險證照-年金考試班(105-04)(簡中)",
                    "sessionTime": "2016/04/01~2016/04/30",
                    "status": 3
                },
                {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1955630,
                    "sessionId": 89956,
                    "sessionName": "投資型保險證照-年金考試班(105下半年)(簡中)",
                    "sessionTime": "2016/07/01~2016/12/31",
                    "status": 2
                },
                ],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(英文)",
                    "enrollmentId": 7736,
                    "sessionId": 25,
                    "sessionName": "簡易外匯機制考試班(9910-9912)(英文)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 3
                },
                {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 14330,
                    "sessionId": 17,
                    "sessionName": "開戶對保作業實務介紹(9910-9912)(英文)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 2
                },
                {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 1765452,
                    "sessionId": 82173,
                    "sessionName": "開戶對保作業實務介紹(105-Q1)(英文)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                },
                {
                    "courseId": 61,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 244471,
                    "sessionId": 7229,
                    "sessionName": "自行查核相關規範及注意事項(100-Q3)(英文)",
                    "sessionTime": "2011/07/01~2011/09/30",
                    "status": 2
                },
                {
                    "courseId": 83,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 1580993,
                    "sessionId": 74983,
                    "sessionName": "認識國標舞(104下半年)(英文)",
                    "sessionTime": "2015/08/04~2015/12/31",
                    "status": 3
                },
                ],
                "ErrorMessage": ""
            };
            switch (params.LanguageCode) {
                case 'en-US':
                    result = resultUS;
                    break;
                case 'zn-CN':
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            return { data: result };
        }
        /**
         * 14.取得修課動作&內容
         * @returns
         */
        function EnrollmentAvailableAction(courseItem) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultType1; /** 一般 */
            var resultType2; /** 測驗 */
            var resultType3; /** 問卷 */
            resultType1 = {
                Status: '200',
                Data: {
                    "lmsItems": [{
                        "action": "Play",
                        "completedTime": "2016/10/27 11:53",
                        "itemId": 3,
                        "itemName": "共同基金銷售關鍵資訊【63分鐘】(影片)",
                        "score": "",
                        "status": "未完成",
                        "type": "課程內容",
                        "viewedTime": "00:00:01"
                    },
                    {
                        "action": "Test",
                        "completedTime": "2016/10/18 10:43",
                        "itemId": 4,
                        "itemName": "共同基金銷售關鍵資訊【測驗】",
                        "score": "",
                        "status": "完成",
                        "type": "測驗",
                        "viewedTime": "00:00:31"
                    },
                    {
                        "action": "???",
                        "completedTime": "",
                        "itemId": 1,
                        "itemName": "這是ZIP教材下載",
                        "score": "不公佈",
                        "status": "",
                        "type": "課程內容",
                        "viewedTime": ""
                    },
                    {
                        "action": "???",
                        "completedTime": "",
                        "itemId": 2,
                        "itemName": "這是PDF教材",
                        "score": "不公佈",
                        "status": "",
                        "type": "課程內容",
                        "viewedTime": ""
                    },
                    {
                        "action": "???",
                        "completedTime": "2016/10/17 21:35",
                        "itemId": 4,
                        "itemName": "信託業務人員職前教育訓練課程【課後問卷】",
                        "score": "",
                        "status": "未曾觀看",
                        "type": "問卷",
                        "viewedTime": "00:00:00"
                    }
                    ],
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": [],
                    "courseSessions": [],
                    "preSurveyItemId": 0,
                    "progress": "1/5",
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "reportTotal": 0,
                    "reports": [],
                    "status": -1
                },
                'ErrorMessage': ''
            };
            resultType2 = {
                "Status": "200",
                "Data": {
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": [
                        "Cancel",
                        "Leave",
                        "Exemption"
                    ],
                    "courseSessions": [],
                    "lmsItems": [{
                        "action": "Test",
                        "completedTime": "2016/12/16 17:17",
                        "itemId": 336655,
                        "itemName": "G-法規-1089金控一般版-法令遵循自評檢核考試班(105上)",
                        "score": "28.0",
                        "status": "未通過",
                        "type": "測驗",
                        "viewedTime": "00:31:06"
                    }],
                    "preSurveyItemId": 5,
                    "progress": "",
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "reportTotal": 0,
                    "reports": [],
                    "status": -1
                },
                "ErrorMessage": ""
            };
            resultType3 = {
                Status: '200',
                Data: {
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": [],
                    "courseSessions": [],
                    "lmsItems": [{
                        "action": "",
                        "completedTime": "2016/09/09 09:18",
                        "itemId": 268699,
                        "itemName": "台新大學暨人資網站改版問卷調查",
                        "score": "",
                        "status": "完成",
                        "type": "問卷",
                        "viewedTime": "00:01:46"
                    }],
                    "preSurveyItemId": 0,
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "progress": "0/1",
                    "status": "未完成",
                    "reportTotal": 0,
                    "reports": []
                },
                'ErrorMessage': ''
            };

            switch (courseItem.courseType) {
                case enumCourseType.classTest:
                    result = resultType2;
                    break;
                case enumCourseType.webTest:
                    result = resultType2;
                    break;
                case enumCourseType.questList:
                    result = resultType3;
                    break;
                default:
                    result = resultType1;
                    break;
            }
            return { data: result };
        }
        /**
         * 15.課程動作(P.18)
         * @returns
         */
        function EnrollmentAction(param) {

            return new Promise((resolve, reject)=>{

                   var result = {
                        Status: 0,
                        Data: {},
                        ErrorMessage: ""
                    };

                    var resultFail = {
                        Status: '200',
                        Data: {
                            failCode: -2,
                            failMessage: '',
                            success: 0,
                        },
                        ErrorMessage: '',
                    };
                    var resultSucess = {
                        Status: '200',
                        Data: {
                            failCode: -1,
                            failMessage: '',
                            success: 1,
                        },
                        ErrorMessage: '',
                    };
                    switch (param.IsProgram) {
                        case 1:
                            result = resultFail;
                            break;
                        default:
                            result = resultSucess;
                            break;
                    }

                    setTimeout(function() {
                        resolve({ data: result });
                    }, 2000);
                 
            })
         
        }

        


        /**
         * 16.金融證照紀錄申請(P.18)
         * @returns
         */
        function FCCertificatedLicenseAdd() {
            var result = {
                Status: '200',
                Data: null,
                ErrorMessage: '',
            };
            return { data: result };
        }
        /**
         * 17.金融證照查詢
         * @returns
         */
        function FCCertificatedLicenseList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "acquireDate": "2016/01/04",
                    "applyDate": "2016/01/05",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "status": "申請取消",
                    "validDate": "2019/01/03",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/01/05 14:01",
                    "workflowItem": "學員",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "",
                    "workflowResult": "取消"
                },
                {
                    "acquireDate": "2016/12/13",
                    "applyDate": "2016/12/15",
                    "id": 6,
                    "name": "信託管理人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2019/12/13",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/12/15 17:36",
                    "workflowItem": "人資經辦",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                },
                {
                    "acquireDate": "2016/12/13",
                    "applyDate": "2016/12/15",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2019/12/13",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/12/15 17:36",
                    "workflowItem": "人資經辦",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                },
                {
                    "acquireDate": "2010/11/10",
                    "applyDate": "2010/11/10",
                    "id": 13,
                    "name": "開戶對保作業資格",
                    "status": "已成功完成",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "",
                    "workflowName": "",
                    "workflowReason": "",
                    "workflowResult": ""
                },
                {
                    "acquireDate": "2016/11/02",
                    "applyDate": "2016/12/15",
                    "id": 46,
                    "name": "人身保險業務員投資型商品資格登錄(登錄壽險公會)",
                    "status": "簽核中",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "人資經辦",
                    "workflowName": "周孟蕎 (1000323),黃昱珩 (1020258),張瑋晏 (1040831)",
                    "workflowReason": "",
                    "workflowResult": ""
                },
                {
                    "acquireDate": "2016/06/29",
                    "applyDate": "2016/07/07",
                    "id": 112,
                    "name": "證券商高級業務員(登錄證券交易所)",
                    "status": "簽核中",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "人資經辦",
                    "workflowName": "周孟蕎 (1000323),黃昱珩 (1020258),張瑋晏 (1040831)",
                    "workflowReason": "",
                    "workflowResult": ""
                },
                {
                    "acquireDate": "2016/04/19",
                    "applyDate": "2016/04/27",
                    "id": 131,
                    "name": "內部講師訓完訓資格",
                    "status": "已成功完成",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/04/27 16:06",
                    "workflowItem": "人資經辦",
                    "workflowName": "張瑋晏 (1040831)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                },
                {
                    "acquireDate": "2013/01/27",
                    "applyDate": "2013/02/19",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2016/01/27",
                    "validStatus": "註銷",
                    "validStatusKey": 2,
                    "workflowDateTime": "2013/02/19 12:00",
                    "workflowItem": "部門管理員代為申請",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "",
                    "workflowResult": "直接核准"
                },
                {
                    "acquireDate": "2013/09/03",
                    "applyDate": "2013/02/19",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2016/09/02",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2013/10/01 16:56",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "TEST(無受訓紀錄)",
                    "workflowResult": "拒絕"
                },
                {
                    "acquireDate": "2016/03/01",
                    "applyDate": "2016/03/09",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2019/03/01",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/03/15 16:18",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "(無測驗合格紀錄)",
                    "workflowResult": "拒絕"
                },
                {
                    "acquireDate": "2016/06/29",
                    "applyDate": "2016/07/07",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2019/06/29",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 17:57",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "(不屬於目前職務所需證照)",
                    "workflowResult": "拒絕"
                },
                {
                    "acquireDate": "2013/12/01",
                    "applyDate": "2013/12/30",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2013/12/30 15:43",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "請書面送保經申請(http://localhost)，通過後由保險系統直接轉入，請勿線上申請。(請書面送保經申請(http://localhost)，通過後由保險系統直接轉入，請勿線上申請。)",
                    "workflowResult": "拒絕"
                },
                {
                    "acquireDate": "2016/06/28",
                    "applyDate": "2016/07/07",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 18:01",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "",
                    "workflowResult": "拒絕"
                },
                {
                    "acquireDate": "2016/07/07",
                    "applyDate": "2016/07/07",
                    "id": 127,
                    "name": "投信投顧業務員-一般業務員(登錄投信投顧公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 17:54",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "",
                    "workflowResult": "拒絕"
                }
                ],
                "ErrorMessage": ""
            };
            return { data: result };
        }

        /**
         * 18.金融證照認列時數(QQ)
         * @returns
         */
        function FCAuthorizedHoursList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "licenseId": 6,
                    "licenseName": "信託管理人員審定合格(登錄信託公會)",
                    "trainingCategory": "在職訓練",
                    "trainingEndDate": "2019/12/13",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                },
                {
                    "licenseId": 7,
                    "licenseName": "信託業務人員審定合格(登錄信託公會)",
                    "trainingCategory": "在職訓練",
                    "trainingEndDate": "2019/12/13",
                    "unfinishHours": "尚缺外訓:6.0,尚缺內訓:12.0",
                    "validStatus": 1
                },
                {
                    "licenseId": 13,
                    "licenseName": "開戶對保作業資格",
                    "trainingCategory": "受訓後取得",
                    "trainingEndDate": "",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                },
                {
                    "licenseId": 131,
                    "licenseName": "內部講師訓完訓資格",
                    "trainingCategory": "受訓後取得",
                    "trainingEndDate": "",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                }
                ],
                "ErrorMessage": ""
            };
            return { data: result };
        }
        /**
         * 19.金融證照紀錄申請
         * @returns
         */
        function ExternalTrainingApplication() {
            var result = {
                Status: '200',
                Data: {
                    failCode: -1,
                    failMessage: '',
                    success: 0,
                },
                ErrorMessage: '',
            };
            return { data: result };
        }
        /**
         * 20.金融證照可報名課程(QQ)
         * @returns
         */
        function FCEnrollableActivities(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultEmpty;
            var resultTW;
            var resultCN;
            var resultUS;

            resultEmpty = {
                "Status": "200",
                "Data": [],
                "ErrorMessage": ""
            };
            resultTW = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 84290,
                    "sessionName": "信託在職-組合式商品簡介 (105-03)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 85914,
                    "sessionName": "信託在職-組合式商品簡介 (105-04)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 82154,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-01)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 83629,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-02)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 84289,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-03)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 85913,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-04)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 82162,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-01)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 83638,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-02)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 84297,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-03)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 85921,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-04)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 82153,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-01)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 83628,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-02)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 84286,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-03)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 85911,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-04)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16816,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 82163,
                    "sessionName": "信託在職─信託業務綜覽【II】(105-01)(繁中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16816,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 83639,
                    "sessionName": "信託在職─信託業務綜覽【II】(105-02)(繁中)"
                }
                ],
                "ErrorMessage": ""
            };
            resultCN = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 82150,
                    "sessionName": "信託業務人員職前訓練課程(105-01)(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 83621,
                    "sessionName": "信託業務人員職前訓練課程(105-02)(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 84282,
                    "sessionName": "信託業務人員職前訓練課程(105-03)(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/01/01 ~ 2016/12/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/01/01",
                    "enrollEnd": "2016/12/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 85908,
                    "sessionName": "信託業務人員職前訓練課程(105年)(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": " ~ ",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "",
                    "enrollEnd": "",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 86934,
                    "sessionName": "信託業務人員職前訓練課程(105年)(複製)(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/02/20 ~ 2016/02/20",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 83791,
                    "sessionName": "2016-0220信託業務人員職前訓練(4小時)-台北場(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/03/12 ~ 2016/03/12",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 83792,
                    "sessionName": "2016-0312信託業務人員職前訓練(4小時)-高雄場(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/03/26 ~ 2016/03/26",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 85389,
                    "sessionName": "2016-0326信託業務人員職前訓練(4小時)-台北場(簡中)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/04/09 ~ 2016/04/09",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 85570,
                    "sessionName": "2016-0409信託業務人員職前訓練(4小時)-台中場(簡中)"
                },
                ],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 82152,
                    "sessionName": "信託在職-結構型商品理論與實務(105-01)(英文)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 83627,
                    "sessionName": "信託在職-結構型商品理論與實務(105-02)(英文)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 84284,
                    "sessionName": "信託在職-結構型商品理論與實務(105-03)(英文)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 85910,
                    "sessionName": "信託在職-結構型商品理論與實務(105-04)(英文)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 82155,
                    "sessionName": "信託在職-組合式商品簡介 (105-01)(英文)"
                },
                {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 83630,
                    "sessionName": "信託在職-組合式商品簡介 (105-02)(英文)"
                },
                ],
                "ErrorMessage": ""
            };
            switch (params.LanguageCode) {
                case "en-US":
                    result = resultUS;
                    break;
                case "zh-CN":
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            //result = resultEmpty; //QQ
            return { data: result };
        }
        /**
         * 21.金融證照紀錄申請
         * @returns
         */
        function LearningRecordCommit() {
            var result = {
                Status: '200',
                Data: null,
                ErrorMessage: '',
            };
            return { data: result };
        }
    }
})();